/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(2);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _init = __webpack_require__(3);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _modal = __webpack_require__(39);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _header = __webpack_require__(40);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _pageBanner = __webpack_require__(71);
	
	var _pageBanner2 = _interopRequireDefault(_pageBanner);
	
	var _hero = __webpack_require__(73);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _insights = __webpack_require__(74);
	
	var _insights2 = _interopRequireDefault(_insights);
	
	var _logos = __webpack_require__(75);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _cards = __webpack_require__(76);
	
	var _cards2 = _interopRequireDefault(_cards);
	
	var _countdown = __webpack_require__(77);
	
	var _countdown2 = _interopRequireDefault(_countdown);
	
	var _video = __webpack_require__(78);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _hsForm = __webpack_require__(79);
	
	var _hsForm2 = _interopRequireDefault(_hsForm);
	
	var _footer = __webpack_require__(81);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _notification = __webpack_require__(82);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** specific section scripts */
	(0, _init2.default)();
	(0, _modal2.default)();
	(0, _header2.default)();
	(0, _pageBanner2.default)();
	(0, _hero2.default)();
	(0, _insights2.default)();
	(0, _logos2.default)();
	(0, _cards2.default)();
	(0, _countdown2.default)();
	(0, _video2.default)();
	(0, _footer2.default)();
	(0, _notification2.default)();
	(0, _hsForm2.default)();
	
	/** additional scripts */
	
	// Offices toggler
	var offices = document.querySelectorAll('.contact_offices ul li');
	offices.forEach(function (office) {
	  office.addEventListener('click', function (event) {
	    if (office.classList.contains('-is-open')) {
	      office.classList.replace('-is-open', '-is-closed');
	      office.parentNode.classList.remove('-is-clicked');
	    } else if (office.classList.contains('-is-closed')) {
	      office.classList.replace('-is-closed', '-is-open');
	      office.parentNode.classList.add('-is-clicked');
	    }
	  });
	});
	
	// Team bio exanders
	var expanders = document.querySelectorAll('.card_content i.expand-bio');
	expanders.forEach(function (expander) {
	  expander.addEventListener('click', function (event) {
	    event.stopPropagation();
	    var cardWrapper = expander.parentElement.parentElement.parentElement;
	    var expandingBio = cardWrapper.querySelector('.card_content_expanded_bio');
	    if (expandingBio) {
	      expandingBio.classList.replace('-closed', '-open');
	    }
	  });
	});
	window.addEventListener('click', function (event) {
	  document.querySelectorAll('.card_content_expanded_bio').forEach(function (bio) {
	    bio.classList.replace('-open', '-closed');
	  });
	});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = init;
	
	var _links = __webpack_require__(4);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _tracking = __webpack_require__(5);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _videos = __webpack_require__(6);
	
	var _videos2 = _interopRequireDefault(_videos);
	
	var _scroller = __webpack_require__(7);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _toggler = __webpack_require__(11);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _selector = __webpack_require__(15);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _tracker = __webpack_require__(16);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _autosize = __webpack_require__(17);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _floatLabel = __webpack_require__(23);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _validator = __webpack_require__(24);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _recaptcha = __webpack_require__(26);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _lightbox = __webpack_require__(28);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _playOnHover = __webpack_require__(29);
	
	var _playOnHover2 = _interopRequireDefault(_playOnHover);
	
	var _map = __webpack_require__(30);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _fade = __webpack_require__(31);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _lazyLoad = __webpack_require__(32);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	var _parallax = __webpack_require__(34);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _reveal = __webpack_require__(35);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _sticky = __webpack_require__(37);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _inspectScroll = __webpack_require__(38);
	
	var _inspectScroll2 = _interopRequireDefault(_inspectScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Load all directives and enhancements
	 */
	function init() {
	  (function () {
	    for (var _len = arguments.length, imports = Array(_len), _key = 0; _key < _len; _key++) {
	      imports[_key] = arguments[_key];
	    }
	
	    return imports.forEach(function (f) {
	      return f();
	    });
	  })(_links2.default, _tracking2.default, _videos2.default, _scroller2.default, _toggler2.default, _selector2.default, _tracker2.default, _autosize2.default, _floatLabel2.default, _validator2.default, _recaptcha2.default, _lightbox2.default, _playOnHover2.default,
	  // swiper,
	  _map2.default, _fade2.default, _lazyLoad2.default, _parallax2.default, _reveal2.default, _sticky2.default, _inspectScroll2.default);
	}
	// import swiper from './directives/media/swiper';

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = linksEnhancement;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Improves the functionality of links depending on their URL's.
	 */
	function linksEnhancement() {
	  var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');
	
	  document.querySelectorAll('a').forEach(function (a) {
	    var href = String(a.getAttribute('href')),
	        cleanLink = Array.from(a.attributes).reduce(function (acc, a) {
	      return acc && !/^data-sw-/.test(a.name);
	    }, true);
	    if (cleanLink) {
	
	      // Animates scroll for anchor links
	      if (href.startsWith('#')) {
	        a.setAttribute('data-sw-scroller', JSON.stringify({ selector: href, to: 'element' }));
	      }
	
	      // Forces new window clicks for asset files
	      var lowerHref = href.toLowerCase();
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var ext = _step.value;
	
	          if (lowerHref.endsWith('.' + ext)) {
	            a.setAttribute('target', '_blank');
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  });
	
	  // Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
	  [].concat(_toConsumableArray(document.querySelectorAll('a')), _toConsumableArray(document.querySelectorAll('button'))).forEach(function (element) {
	    element.addEventListener('click', function (_) {
	      return element.blur();
	    });
	  });
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trackingEnhancement;
	/**
	 * Enables automatic tracking on links and forms.
	 * @param {HTMLElement} [context=document.body] - Optional DOM context.
	 */
	function trackingEnhancement() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var trackingElements = [{ selector: 'a[href^="mailto:"]', label: "Email click" }, { selector: 'a[href^="tel:"]', label: "Phone click" }];
	
	  // Tag all tracing elements.
	  trackingElements.forEach(function (element) {
	    var el = context.querySelector(element.selector),
	        label = element.label;
	    if (el) el.setAttribute('data-sw-tracker', JSON.stringify({ label: label }));
	  });
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = videos;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function videos() {
	  var playButtons = [].concat(_toConsumableArray(document.querySelectorAll('.media_vid-container')));
	
	  if (playButtons.length) {
	    playButtons.forEach(function (btn) {
	      var videoElement = btn.previousSibling;
	
	      btn.addEventListener('click', function (e) {
	        if (videoElement.paused) {
	          videoElement.play();
	          btn.classList.add('is-hidden');
	        } else {
	          videoElement.pause();
	          btn.classList.remove('is-hidden');
	        }
	      });
	    });
	  }
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollerDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	/**
	 * @module directives/action/scroller
	 */
	
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	/**
	 * Scrolls to a point on the page when an element is clicked.
	 * Scrolls to top: <button data-sw-scroller="top">Top</button>
	 * Scrolls to bottom: <button data-sw-scroller="bottom">Bottom</button>
	 * Scrolls to element by ID: <button data-sw-scroller="#element">Element</button>
	 */
	function scrollerDirective() {
	  document.querySelectorAll('[data-sw-scroller]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-scroller'),
	        settings = (0, _parse.directiveSettings)(data, {
	      to: 'top',
	      selector: null,
	      speed: 500
	    }, 'to');
	
	    element.addEventListener('click', function (event) {
	      event.preventDefault();
	      clearInterval(breakTimeout);
	
	      breakable = false;
	      breakTimeout = setTimeout(function (_) {
	        return breakable = true;
	      }, 100);
	
	      var top = 0;
	      switch (settings.to) {
	        case 'top':
	          top = 0;
	          break;
	        case 'bottom':
	          top = docEl.scrollHeight - docEl.clientHeight;
	          break;
	        case 'element':
	          var headerHeight = document.querySelector('header').offsetHeight;
	          top = document.querySelector(settings.selector).getBoundingClientRect().top + window.scrollY - window.outerHeight + window.innerHeight - headerHeight * 1.5;
	          break;
	        default:
	          top = document.querySelector(settings.to).offsetTop - 120;
	      }
	
	      window.scrollTo({
	        top: Math.min(top, docEl.scrollHeight - docEl.clientHeight),
	        behavior: 'smooth'
	      });
	    });
	  });
	
	  if (!bound) {
	    bound = true;
	    (0, _window.bindEvents)(document.body, 'scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function (event) {
	      if (breakable) {
	        switch (event.type) {
	          case 'mousedown':
	          case 'mousewheel':
	          case 'touchstart':
	            document.body.scroll({ top: docEl.scrollTop });break;
	        }
	      }
	    });
	  }
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.directiveSettings = directiveSettings;
	/**
	 * JSON fuctions and helpers/
	 * @module utils/parse
	 */
	
	/**
	 * Parses the JSON from a directive.
	 * @param {JSON} data - JSON formatted string.
	 * @param {Map} [defaults={}] - Default values to set possibly overidden by JSON data.
	 * @param {String} [targetProperty=false] - Single property to set the data to.
	 */
	function directiveSettings(data) {
	  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var targetProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var settings = Object.assign({}, defaults);
	
	  if (data) {
	    var parsedData = void 0;
	    try {
	      parsedData = JSON.parse(data);
	    } catch (e) {
	      parsedData = data;
	    }
	
	    if (parsedData instanceof Object && !Array.isArray(parsedData)) Object.assign(settings, parsedData);else if (targetProperty) settings[targetProperty] = parsedData;else console.error("Error parsing settings: \"" + data + "\"");
	  }
	
	  return settings;
	}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProperties = getProperties;
	exports.getWidth = getWidth;
	exports.getHeight = getHeight;
	exports.getScrollTop = getScrollTop;
	exports.getScrollLeft = getScrollLeft;
	exports.getScrollWidth = getScrollWidth;
	exports.getScrollHeight = getScrollHeight;
	exports.bindEvents = bindEvents;
	exports.onResize = onResize;
	exports.onScroll = onScroll;
	
	var _drawing = __webpack_require__(10);
	
	/**
	 * Module for window state & scroll/resize event hooks.
	 * @module utils/window
	 */
	
	/** Watch and update window properties  */
	var properties = {},
	    updateDimensions = function updateDimensions(_) {
	  properties.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	  properties.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	},
	    updateScroll = function updateScroll(_) {
	  properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	  properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	  properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
	  properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	};
	updateDimensions();
	updateScroll();
	window.addEventListener('load', function (_) {
	  updateDimensions();updateScroll();
	});
	window.addEventListener('resize', function (_) {
	  updateDimensions();updateScroll();
	});
	window.addEventListener('scroll', updateScroll);
	
	/**
	 * Returns all the above properties of the window object.
	 * @returns {Object}
	 */
	function getProperties() {
	  return Object.assign({}, properties);
	}
	
	/**
	 * Returns the width of the window in pixels.
	 * @returns {Number}
	 */
	function getWidth() {
	  return properties.width;
	}
	
	/**
	 * Returns the height of the window in pixels.
	 * @returns {Number}
	 */
	function getHeight() {
	  return properties.height;
	}
	
	/**
	 * Returns the top scroll value of the window in pixels.
	 * @returns {Number}
	 */
	function getScrollTop() {
	  return properties.scrollTop;
	}
	
	/**
	 * Returns the left scroll value of the window in pixels.
	 * @returns {Number}
	 */
	function getScrollLeft() {
	  return properties.scrollLeft;
	}
	
	/**
	 * Returns the scrollable width of the window in pixels.
	 * @returns {Number}
	 */
	function getScrollWidth() {
	  return properties.scrollWidth;
	}
	
	/**
	 * Returns the scrollable height of the window in pixels.
	 * @returns {Number}
	 */
	function getScrollHeight() {
	  return properties.scrollHeight;
	}
	
	/**
	 * Binds a series of events to an element. Sugar for HTMLElement.addEventListner.
	 * @param {HTMLElement} element - The element top bind to.
	 * @param {String} events - A space delimimetered list of events to binds (as with jQuery.bind).
	 * @param {Function} callback - The callback function to bind.
	 */
	function bindEvents(element, events, callback) {
	  var eventKeys = events.split(' ');
	  if (Array.isArray(eventKeys)) eventKeys.forEach(function (key) {
	    return element.addEventListener(key, callback);
	  });
	}
	
	/**
	 * Binds a debounced version of the passed callback to window.resize.
	 * @param {Function} callback - The callback function to bind.
	 * @returns {Function} - A function to unbind the events.
	 */
	function onResize(callback) {
	  var cb = (0, _drawing.debounce)(callback);
	
	  window.addEventListener('resize', cb);
	  return function (_) {
	    return window.removeEventListener('resize', cb);
	  };
	}
	
	/**
	 * Binds a debounced version of the passed callback to window.scroll.
	 * @param {Function} callback - The callback function to bind.
	 * @returns {Function} - A function to unbind the events.
	 */
	function onScroll(callback) {
	  var cb = (0, _drawing.debounce)(callback);
	  window.addEventListener('resize', cb);
	  window.addEventListener('scroll', cb);
	  return function (_) {
	    window.removeEventListener('resize', cb);
	    window.removeEventListener('scroll', cb);
	  };
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.debounce = debounce;
	exports.redraw = redraw;
	exports.newElement = newElement;
	exports.slideDown = slideDown;
	exports.slideUp = slideUp;
	/**
	 * DOM drawing, animations and frame control.
	 * @module utils/drawing
	 */
	
	/**
	 * Requests an animation frame.
	 * @param {Function} callback - The function to call om frame/timeout
	 * @returns {Number} - The frame/timeout id
	 */
	function frame(callback) {
	  return typeof requestAnimationFrame === 'undefined' ? setTimeout(callback, 0) : requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 * @param {Number} id - The frame/timeout id
	 */
	function unframe(id) {
	  typeof cancelAnimationFrame === 'undefined' ? clearTimeout(id) : cancelAnimationFrame(id);
	}
	
	/**
	 * Creates and returns a debounced version of a function.
	 * @param {Function} callback - The function to debounce.
	 * @returns {Function} - The debounced callback function.
	 */
	function debounce(callback) {
	  var id = void 0;
	  return function (event) {
	    unframe(id);
	    id = frame(function (_) {
	      return callback(event);
	    });
	  };
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 * @param {HTMLElement} element - The element to read for reflow.
	 */
	function redraw(element) {
	  element.offsetWidth;
	}
	
	/**
	 * Creates and returns a new DOM element.
	 * @param {String} [type='div'] - The element type.
	 * @param {Map} [attributes={}] - The element attributes.
	 * @param {String} [html=null] - If set the returned attribute will be the first node of the passed html.
	 * @returns {HTMLElement}
	 */
	function newElement() {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
	  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var html = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var el = document.createElement(type);
	  if (!el) return null;
	  Object.keys(attributes).forEach(function (key) {
	    return el[key] = attributes[key];
	  });
	  if (html) {
	    el.innerHTML = html;
	    return el.firstChild;
	  } else {
	    return el;
	  }
	}
	
	/**
	 * Emulates jQuery.slideDown
	 * @param {HTMLElement} element - The element to animate.
	 * @param {Number} duration - The length of the animation.
	 * @param {Function} done - Callback once completed.
	 */
	function slideDown(element, duration, done) {
	  element.style.transitionProperty = 'height, margin, padding';
	  element.style.transitionDuration = duration + 'ms';
	  element.style.boxSizing = 'border-box';
	  element.style.height = element.offsetHeight + 'px';
	  element.offsetHeight;
	  element.style.overflow = 'hidden';
	  element.style.height = 0;
	  element.style.paddingTop = 0;
	  element.style.paddingBottom = 0;
	  element.style.marginTop = 0;
	  element.style.marginBottom = 0;
	  window.setTimeout(function (_) {
	    element.style.display = 'none';
	    element.style.removeProperty('height');
	    element.style.removeProperty('padding-top');
	    element.style.removeProperty('padding-bottom');
	    element.style.removeProperty('margin-top');
	    element.style.removeProperty('margin-bottom');
	    element.style.removeProperty('overflow');
	    element.style.removeProperty('transition-duration');
	    element.style.removeProperty('transition-property');
	    done();
	  }, duration);
	}
	
	/**
	 * Emulates jQuery.slideUp
	 * @param {HTMLElement} element - The element to animate.
	 * @param {Number} duration - The length of the animation.
	 * @param {Function} done - Callback once completed.
	 */
	function slideUp(element, duration, done) {
	  element.style.removeProperty('display');
	  var display = window.getComputedStyle(element).display;
	  if (display === 'none') display = 'block';
	  element.style.display = display;
	  var height = element.offsetHeight;
	  element.style.overflow = 'hidden';
	  element.style.height = 0;
	  element.style.paddingTop = 0;
	  element.style.paddingBottom = 0;
	  element.style.marginTop = 0;
	  element.style.marginBottom = 0;
	  element.offsetHeight;
	  element.style.boxSizing = 'border-box';
	  element.style.transitionProperty = "height, margin, padding";
	  element.style.transitionDuration = duration + 'ms';
	  element.style.height = height + 'px';
	  element.style.removeProperty('padding-top');
	  element.style.removeProperty('padding-bottom');
	  element.style.removeProperty('margin-top');
	  element.style.removeProperty('margin-bottom');
	  window.setTimeout(function (_) {
	    element.style.removeProperty('height');
	    element.style.removeProperty('overflow');
	    element.style.removeProperty('transition-duration');
	    element.style.removeProperty('transition-property');
	    done();
	  }, duration);
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = togglerDirective;
	
	var _parse = __webpack_require__(8);
	
	var _data = __webpack_require__(12);
	
	var _toggler = __webpack_require__(13);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module directives/action/toggler
	 */
	
	/**
	 * Toggles the visual display of an element on the page.
	 * Contains action directives for interacting with a toggler element:
	 *  - toggler-open
	 *  - toggler-close
	 *  - toggler-toggle
	 *  - toggler-select
	 *  - toggler-class
	 */
	function togglerDirective() {
	
	  // Create togglers
	  document.querySelectorAll('[data-sw-toggler]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-toggler'),
	        settings = (0, _parse.directiveSettings)(data, {
	      open: true,
	      transition: false
	    }, 'open');
	    (0, _data.putData)(element, 'toggler', new _toggler2.default(element, settings));
	  });
	
	  /**
	   * Action togglers.
	   */
	
	  var _loop = function _loop(action) {
	    document.querySelectorAll('[data-sw-toggler-' + action + ']').forEach(function (element) {
	
	      var data = element.getAttribute('data-sw-toggler-' + action),
	          settings = (0, _parse.directiveSettings)(data, {
	        target: null,
	        on: 'click',
	        prevent: true
	      }, 'target');
	
	      element.addEventListener(settings.on, function (event) {
	        if (settings.prevent) event.preventDefault();
	        var target = settings.target ? document.querySelector(settings.target) : element.closest('[data-sw-toggler]'),
	            toggler = (0, _data.getData)(target, 'toggler');
	        if (toggler) toggler[action]();
	      });
	    });
	  };
	
	  var _arr = ['open', 'close', 'toggle'];
	  for (var _i = 0; _i < _arr.length; _i++) {
	    var action = _arr[_i];
	    _loop(action);
	  }
	
	  /**
	   * Controls togglers with a <select> field
	   * Should be used with the [data-sw-selector] directive for best usability
	   */
	  document.querySelectorAll('select[data-sw-toggler-select]').forEach(function (element) {
	
	    var values = element.querySelector('option').map(function (el) {
	      return el.value;
	    }),
	        togglers = values.map(function (selector) {
	      return (0, _data.getData)(element.querySelector(selector), 'toggler');
	    });
	
	    togglers.forEach(function (toggler) {
	      if (toggler) {
	        var value = values[togglers.indexOf(toggler)] || null;
	        if (value) toggler.on('open', function (_) {
	          return element.value = value;
	        });
	      }
	    });
	
	    element.addEventListener('change', function (_) {
	      return togglers[values.indexOf(element.value)].open();
	    });
	  });
	
	  /**
	   * Class togglers.
	   */
	  document.querySelectorAll('[data-sw-toggler-class]').forEach(function (element) {
	
	    var data = element.getAttribute('data-sw-toggler-class'),
	        settings = (0, _parse.directiveSettings)(data, {
	      target: null,
	      openClass: 'is-open',
	      closedClass: 'is-closed'
	    }, 'target');
	
	    var target = settings.target ? document.querySelector(settings.target) : element.closest('[data-sw-toggler]'),
	        toggler = (0, _data.getData)(target, 'toggler');
	
	    if (toggler) {
	      var updateClasses = function updateClasses(_) {
	        element.classList.remove(toggler.isOpen ? settings.closedClass : settings.openClass);
	        element.classList.add(toggler.isOpen ? settings.openClass : settings.closedClass);
	      };
	      toggler.on('toggle', updateClasses);
	      updateClasses();
	    }
	  });
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uniqueId = uniqueId;
	exports.putData = putData;
	exports.getData = getData;
	/**
	 * @module utils/data
	 */
	
	/**
	 * Generates a unique ID.
	 * @returns {String}
	 */
	var existingUniqueIds = {};
	function uniqueId() {
	  var range = Math.pow(10, 9);
	  var id = null;
	  while (!id || existingUniqueIds[id]) {
	    id = 'id' + (Math.random() * range | 0).toString(36);
	  }existingUniqueIds[id] = true;
	  return id;
	}
	
	/**
	 * Object data storage.
	 */
	var elementDataStorage = {
	  _storage: new WeakMap(),
	  put: function put(element, key, obj) {
	    if (!this._storage.has(element)) {
	      this._storage.set(element, new Map());
	    }
	    this._storage.get(element).set(key, obj);
	  },
	  get: function get(element, key) {
	    return this._storage.get(element).get(key);
	  },
	  has: function has(element, key) {
	    return this._storage.has(element) && this._storage.get(element).has(key);
	  },
	  remove: function remove(element, key) {
	    var ret = this._storage.get(element).delete(key);
	    if (!this._storage.get(element).size === 0) {
	      this._storage.delete(element);
	    }
	    return ret;
	  }
	
	  /**
	   * Attaches an arbitrary value reference to an element (emulates jQuery.data())
	   * @param   {HTMLElement} element - The element to attach the data to.
	   * @param   {String} attribute - The attribute name to store the data at.
	   * @param   {*} value - The data value to store; can be any valid JS object or variable.
	   * @returns {*} - The passed value, just returned back again.
	   */
	};function putData(element, attribute) {
	  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  // Create a datastore key and add it to the element
	  var dataStoreId = uniqueId();
	  element.setAttribute('data-' + attribute + '-dataStoreId', dataStoreId);
	
	  // Put it into storage
	  if (!elementDataStorage.has(element, dataStoreId)) elementDataStorage.put(element, dataStoreId, value);
	  return value;
	}
	
	/**
	 * Returns the value from the passed element and attribute
	 * @param   {HTMLElement} element - The element to get the data from.
	 * @param   {String} attribute - The attribute to get the data from.
	 * @returns {*} - The found value.
	 */
	function getData(element, attribute) {
	
	  // Get the storage key
	  var dataAttribute = 'data-' + attribute + '-dataStoreId',
	      dataStoreId = element ? element.getAttribute(dataAttribute) : null;
	  if (!dataStoreId) {
	    console.error('Data store key: "' + dataAttribute + '" does not exist');
	    return;
	  }
	
	  // Get the value from storage
	  if (!elementDataStorage.has(element, dataStoreId)) {
	    console.error('Unable to get data from element attribute "' + dataAttribute + '"');
	    return;
	  } else {
	    return elementDataStorage.get(element, dataStoreId);
	  }
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transitionTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _emitter = __webpack_require__(14);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Module for toggling the visual state of elements.
	 * @module utils/toggler
	 */
	
	/** Transition type map */
	var transitionTypes = exports.transitionTypes = {
	  css: {
	    init: function init(toggler) {
	      toggler.element.addEventListener('transitionend', function (event) {
	        if (event.target === toggler.element) toggler.transitionEnd();
	      });
	    }
	  },
	  height: {
	    init: function init(toggler) {
	      toggler.element.style.display = toggler.isOpen ? '' : 'none';
	    },
	    start: function start(toggler) {
	      if (toggler.isOpen) {
	        (0, _drawing.slideUp)(toggler.element, 300, function (_) {
	          return toggler.transitionEnd();
	        });
	      } else {
	        (0, _drawing.slideDown)(toggler.element, 300, function (_) {
	          return toggler.transitionEnd();
	        });
	      }
	    },
	    skip: function skip(toggler) {
	      toggler.element.style.display = toggler.isOpen ? '' : 'none';
	    }
	  }
	};
	
	/**
	 * Toggler class for toggling the visual state of an element.
	 * @extends Emitter
	 */
	
	var Toggler = function (_Emitter) {
	  _inherits(Toggler, _Emitter);
	
	  /**
	   * Create a toggler.
	   * @param {HTMLElement} element - The element to toggle.
	   * @param {Map} settings - The toggle settings.
	   */
	  function Toggler(element) {
	    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Toggler);
	
	    var _this = _possibleConstructorReturn(this, (Toggler.__proto__ || Object.getPrototypeOf(Toggler)).call(this));
	
	    _this.element = element;
	    _this.isOpen = typeof settings.open === 'boolean' ? settings.open : true;
	    _this.transition = settings.transition in transitionTypes ? settings.transition : false;
	
	    _this.transitionInit();
	    return _this;
	  }
	
	  /**
	   * Toggle.
	   * @param {Boolean} isOpen - The toggle state.
	   * @param {Boolean} transition - Whether to use transitions.
	   */
	
	
	  _createClass(Toggler, [{
	    key: 'toggle',
	    value: function toggle(isOpen, transition) {
	      isOpen = typeof isOpen === 'boolean' ? isOpen : !this.isOpen;
	      transition = typeof transition === 'boolean' ? transition : true;
	
	      if (this.isOpen !== isOpen) {
	        this.isOpen = isOpen;
	
	        if (this.transition && transition) {
	          this.transitionStart();
	        } else {
	          this.element.classList.remove('is-before-opening');
	          this.element.classList.remove('is-opening');
	          this.element.classList.remove('is-before-closing');
	          this.element.classList.remove('is-closing');
	          this.element.classList.toggle('is-open', this.isOpen);
	          this.element.classList.toggle('is-closed', !this.isOpen);
	
	          this.transitionSkip();
	        }
	
	        this.trigger('toggle');
	        this.trigger(this.isOpen ? 'open' : 'close');
	      }
	    }
	
	    /**
	     * Set open.
	     * @param {Boolean} transition - Whether to use transitions.
	     */
	
	  }, {
	    key: 'open',
	    value: function open(transition) {
	      this.toggle(true, transition);
	    }
	
	    /**
	     * Set closed.
	     * @param {Boolean} transition - Whether to use transitions.
	     */
	
	  }, {
	    key: 'close',
	    value: function close(transition) {
	      this.toggle(false, transition);
	    }
	
	    /** 
	     * Init transition.
	    */
	
	  }, {
	    key: 'transitionInit',
	    value: function transitionInit() {
	      this.element.classList.remove('is-before-opening');
	      this.element.classList.remove('is-opening');
	      this.element.classList.remove('is-before-closing');
	      this.element.classList.remove('is-closing');
	      this.element.classList.toggle('is-open', this.isOpen);
	      this.element.classList.toggle('is-closed', !this.isOpen);
	
	      var transitionType = transitionTypes[this.transition];
	      if (transitionType && transitionType.init) transitionType.init(this);
	    }
	
	    /**
	     * Start transition.
	    */
	
	  }, {
	    key: 'transitionStart',
	    value: function transitionStart() {
	
	      if (this.isOpen) {
	
	        if (this.element.classList.contains('is-before-closing')) {
	
	          this.element.classList.remove('is-before-closing');
	          this.element.classList.add('is-open');
	        } else if (this.element.classList.contains('is-closing')) {
	
	          this.element.classList.remove('is-before-closing');
	          this.element.classList.remove('is-closing');
	          this.element.classList.add('is-opening');
	        } else {
	
	          this.element.classList.remove('is-closed');
	          this.element.classList.add('is-before-opening');
	
	          (0, _drawing.redraw)(this.element);
	
	          this.element.classList.remove('is-before-opening');
	          this.element.classList.add('is-opening');
	        }
	      } else {
	
	        if (this.element.classList.contains('is-before-opening')) {
	
	          this.element.classList.remove('is-before-opening');
	          this.element.classList.add('is-closed');
	        } else if (this.element.classList.contains('is-opening')) {
	
	          this.element.classList.remove('is-opening');
	          this.element.classList.add('is-closing');
	        } else {
	
	          this.element.classList.remove('is-open');
	          this.element.classList.add('is-before-closing');
	
	          (0, _drawing.redraw)(this.element);
	
	          this.element.classList.remove('is-before-closing');
	          this.element.classList.add('is-closing');
	        }
	      }
	
	      var transitionType = transitionTypes[this.transition];
	      if (transitionType && transitionType.start) {
	        transitionType.start(this);
	      }
	
	      this.trigger('transitionStart');
	    }
	
	    /** 
	     * End transition.
	    */
	
	  }, {
	    key: 'transitionEnd',
	    value: function transitionEnd() {
	      if (this.isOpen) {
	
	        this.element.classList.remove('is-opening');
	        this.element.classList.add('is-open');
	      } else {
	
	        this.element.classList.remove('is-closing');
	        this.element.classList.add('is-closed');
	      }
	
	      var transitionType = transitionTypes[this.transition];
	      if (transitionType && transitionType.end) transitionType.end(this);
	
	      this.trigger('transitionEnd');
	    }
	
	    /** 
	     * Ski[p tranistion.
	    */
	
	  }, {
	    key: 'transitionSkip',
	    value: function transitionSkip() {
	      var transitionType = transitionTypes[this.transition];
	      if (transitionType && transitionType.skip) transitionType.skip(this);
	    }
	  }]);
	
	  return Toggler;
	}(_emitter2.default);
	
	exports.default = Toggler;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Emitter module.
	 * @module utils/emitter
	 */
	
	/** Class for emitting custom events */
	var Emitter = function () {
	
	  /** Create the emitter */
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    this.events = {};
	  }
	
	  /** 
	   * Bind callback to an event type.
	   * @param {String} type - The event type.
	   * @param {Function} callback - The function to bind to the event.
	   */
	
	
	  _createClass(Emitter, [{
	    key: "on",
	    value: function on(type, callback) {
	      if (!(type in this.events)) this.events[type] = [];
	      this.events[type].push(callback);
	    }
	
	    /** 
	     * Unbinds a callback from an event type.
	     * @param {String} type - The event type.
	     * @param {Function} [callback=null] - The function to unbind from the event.
	     */
	
	  }, {
	    key: "off",
	    value: function off(type) {
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (callback && type in this.events) {
	        var newList = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var cb = _step.value;
	
	            if (cb !== callback) newList.push(cb);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.events[type] = newList;
	      } else {
	        delete this.events[type];
	      }
	    }
	
	    /** 
	     * Triggers an event.
	     * @param {String} type - The event type.
	     */
	
	  }, {
	    key: "trigger",
	    value: function trigger(type) {
	      var event = {};
	      if (type in this.events) {
	        event.type = type;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var cb = _step2.value;
	            cb.call(this, event);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	  }]);
	
	  return Emitter;
	}();
	
	exports.default = Emitter;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = selectorDirective;
	
	var _parse = __webpack_require__(8);
	
	var _data = __webpack_require__(12);
	
	/**
	 * @module directives/action/selector
	 */
	
	/**
	 * Creates selectors.
	 */
	function selectorDirective() {
	
	  document.querySelectorAll('[data-sw-selector]').forEach(function (element) {
	
	    var data = element.getAttribute('data-sw-selector'),
	        settings = (0, _parse.directiveSettings)(data, {
	      selector: '[data-sw-toggler]'
	    }, 'selector');
	
	    var togglers = element.querySelectorAll(settings.selector).map(function (el) {
	      return (0, _data.getData)(el, 'toggler');
	    });
	
	    var selectToggler = function selectToggler(toggler) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = togglers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var otherToggler = _step.value;
	
	          if (otherToggler !== toggler) otherToggler.close();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    };
	
	    togglers.forEach(function (toggler) {
	      return toggler.on('open', function (_) {
	        return selectToggler(toggler);
	      });
	    });
	  });
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trackerDirective;
	
	var _parse = __webpack_require__(8);
	
	/**
	 * @module directives/action/tracker
	 */
	
	/**
	 * Track event buy sending to SEO services.
	 * @param {String} [category='lead'] - The event category.
	 * @param {String} [action='click'] - The event type.
	 * @param {String} [label=''] - The event label.
	 * @param {Number} [timeout=1000] - The fail timeout.
	 * @returns {Promise}
	 */
	function trackEvent() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lead';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';
	  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	
	  var promises = [];
	
	  // Google Analytics
	  if (typeof ga === 'function') {
	
	    promises.push(new Promise(function (resolve, reject) {
	      ga('send', {
	        hitType: 'event',
	        eventCategory: category,
	        eventAction: action,
	        eventLabel: label,
	        hitCallback: function hitCallback(_) {
	          return resolve();
	        }
	      });
	      setTimeout(function (_) {
	        return reject();
	      }, timeout);
	    }));
	  }
	
	  // Facebook Pixel
	  if (typeof fqb === 'function') {
	    promises.push(new Promise(function (resolve, reject) {
	      fbq('track', 'Lead');
	      resolve();
	    }));
	  }
	
	  return Promise.all(promises);
	}
	
	/**
	 * Apply tracker controls.
	 */
	function trackerDirective() {
	  document.querySelectorAll('[data-sw-tracker]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-tracker'),
	        settings = (0, _parse.directiveSettings)(data, {
	      on: 'auto',
	      type: 'lead',
	      label: '',
	      timeout: 1000
	    }, 'label');
	
	    if (settings.on === 'auto') settings.on = element.matches('form') ? 'submit' : 'click';
	
	    var tracker = function tracker(event) {
	
	      event.preventDefault();
	      event.stopImmediatePropagation();
	
	      var trigger = function trigger(_) {
	        element.removeEventListener(settings.on, tracker);
	
	        if (settings.on === 'click' && element.matches('a[href]')) {
	          element.dispatchEvent(new MouseEvent('click'));
	        } else {
	          if (settings.on === 'submit') {
	            element.dispatchEvent(new SubmitEvent("submit", { submitter: event.target }));
	          } else if (settings.on === 'click') {
	            element.dispatchEvent(new MouseEvent('click'));
	          }
	        }
	      };
	      trackEvent(settings.type, settings.on, settings.label, settings.timeout).then(trigger).catch(trigger);
	    };
	
	    element.addEventListener(settings.on, tracker);
	  });
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = autosizeDirective;
	
	var _autosize = __webpack_require__(18);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _iframeResizer = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module directives/form/autosize
	 */
	
	/**
	 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
	 * @see https://github.com/jackmoore/autosize
	 * @param {HTMLElement} [context=document.body] - Optional DOM context.
	 */
	function autosizeDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  (0, _autosize2.default)(context.querySelector('textarea[data-sw-autosize]'));
	  context.querySelectorAll('iframe[data-sw-autosize]').forEach(function (element) {
	    (0, _iframeResizer.iframeResizer)({ checkOrigin: false }, element);
	  });
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = __webpack_require__(20)


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	exports.iframeResizer = __webpack_require__(21);
	exports.iframeResizerContentWindow = __webpack_require__(22);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var count = 0,
	    logEnabled = false,
	    hiddenCheckEnabled = false,
	    msgHeader = 'message',
	    msgHeaderLen = msgHeader.length,
	    msgId = '[iFrameSizer]', //Must match iframe msg ID
	    msgIdLen = msgId.length,
	    pagePosition = null,
	    requestAnimationFrame = window.requestAnimationFrame,
	    resetRequiredMethods = {
	      max: 1,
	      scroll: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    settings = {},
	    timer = null,
	    logId = 'Host Page',
	    defaults = {
	      autoResize: true,
	      bodyBackground: null,
	      bodyMargin: null,
	      bodyMarginV1: 8,
	      bodyPadding: null,
	      checkOrigin: true,
	      inPageLinks: false,
	      enablePublicMethods: true,
	      heightCalculationMethod: 'bodyOffset',
	      id: 'iFrameResizer',
	      interval: 32,
	      log: false,
	      maxHeight: Infinity,
	      maxWidth: Infinity,
	      minHeight: 0,
	      minWidth: 0,
	      resizeFrom: 'parent',
	      scrolling: false,
	      sizeHeight: true,
	      sizeWidth: false,
	      warningTimeout: 5000,
	      tolerance: 0,
	      widthCalculationMethod: 'scroll',
	      closedCallback: function() {},
	      initCallback: function() {},
	      messageCallback: function() {
	        warn('MessageCallback function not defined');
	      },
	      resizedCallback: function() {},
	      scrollCallback: function() {
	        return true;
	      }
	    };
	
	  function getMutationObserver() {
	    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	  }
	
	  function addEventListener(obj, evt, func) {
	    /* istanbul ignore else */ // Not testable in PhantonJS
	    if ('addEventListener' in window) {
	      obj.addEventListener(evt, func, false);
	    } else if ('attachEvent' in window) {
	      //IE
	      obj.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function setupRequestAnimationFrame() {
	    var vendors = ['moz', 'webkit', 'o', 'ms'],
	      x;
	
	    // Remove vendor prefixing if prefixed and break early if not
	    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
	      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    }
	
	    if (!requestAnimationFrame) {
	      log('setup', 'RequestAnimationFrame not supported');
	    }
	  }
	
	  function getMyID(iframeId) {
	    var retStr = 'Host page: ' + iframeId;
	
	    if (window.top !== window.self) {
	      if (window.parentIFrame && window.parentIFrame.getId) {
	        retStr = window.parentIFrame.getId() + ': ' + iframeId;
	      } else {
	        retStr = 'Nested host page: ' + iframeId;
	      }
	    }
	
	    return retStr;
	  }
	
	  function formatLogHeader(iframeId) {
	    return msgId + '[' + getMyID(iframeId) + ']';
	  }
	
	  function isLogEnabled(iframeId) {
	    return settings[iframeId] ? settings[iframeId].log : logEnabled;
	  }
	
	  function log(iframeId, msg) {
	    output('log', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function info(iframeId, msg) {
	    output('info', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function warn(iframeId, msg) {
	    output('warn', iframeId, msg, true);
	  }
	
	  function output(type, iframeId, msg, enabled) {
	    if (true === enabled && 'object' === typeof window.console) {
	      console[type](formatLogHeader(iframeId), msg);
	    }
	  }
	
	  function iFrameListener(event) {
	    function resizeIFrame() {
	      function resize() {
	        setSize(messageData);
	        setPagePosition(iframeId);
	        callback('resizedCallback', messageData);
	      }
	
	      ensureInRange('Height');
	      ensureInRange('Width');
	
	      syncResize(resize, messageData, 'init');
	    }
	
	    function processMsg() {
	      var data = msg.substr(msgIdLen).split(':');
	
	      return {
	        iframe: settings[data[0]] && settings[data[0]].iframe,
	        id: data[0],
	        height: data[1],
	        width: data[2],
	        type: data[3]
	      };
	    }
	
	    function ensureInRange(Dimension) {
	      var max = Number(settings[iframeId]['max' + Dimension]),
	        min = Number(settings[iframeId]['min' + Dimension]),
	        dimension = Dimension.toLowerCase(),
	        size = Number(messageData[dimension]);
	
	      log(
	        iframeId,
	        'Checking ' + dimension + ' is in range ' + min + '-' + max
	      );
	
	      if (size < min) {
	        size = min;
	        log(iframeId, 'Set ' + dimension + ' to min value');
	      }
	
	      if (size > max) {
	        size = max;
	        log(iframeId, 'Set ' + dimension + ' to max value');
	      }
	
	      messageData[dimension] = '' + size;
	    }
	
	    function isMessageFromIFrame() {
	      function checkAllowedOrigin() {
	        function checkList() {
	          var i = 0,
	            retCode = false;
	
	          log(
	            iframeId,
	            'Checking connection is from allowed list of origins: ' +
	              checkOrigin
	          );
	
	          for (; i < checkOrigin.length; i++) {
	            if (checkOrigin[i] === origin) {
	              retCode = true;
	              break;
	            }
	          }
	          return retCode;
	        }
	
	        function checkSingle() {
	          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
	          log(iframeId, 'Checking connection is from: ' + remoteHost);
	          return origin === remoteHost;
	        }
	
	        return checkOrigin.constructor === Array ? checkList() : checkSingle();
	      }
	
	      var origin = event.origin,
	        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
	
	      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
	        throw new Error(
	          'Unexpected message received from: ' +
	            origin +
	            ' for ' +
	            messageData.iframe.id +
	            '. Message was: ' +
	            event.data +
	            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
	        );
	      }
	
	      return true;
	    }
	
	    function isMessageForUs() {
	      return (
	        msgId === ('' + msg).substr(0, msgIdLen) &&
	        msg.substr(msgIdLen).split(':')[0] in settings
	      ); //''+Protects against non-string msg
	    }
	
	    function isMessageFromMetaParent() {
	      //Test if this message is from a parent above us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 };
	
	      if (retCode) {
	        log(iframeId, 'Ignoring init message from meta parent page');
	      }
	
	      return retCode;
	    }
	
	    function getMsgBody(offset) {
	      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
	    }
	
	    function forwardMsgFromIFrame(msgBody) {
	      log(
	        iframeId,
	        'MessageCallback passed: {iframe: ' +
	          messageData.iframe.id +
	          ', message: ' +
	          msgBody +
	          '}'
	      );
	      callback('messageCallback', {
	        iframe: messageData.iframe,
	        message: JSON.parse(msgBody)
	      });
	      log(iframeId, '--');
	    }
	
	    function getPageInfo() {
	      var bodyPosition = document.body.getBoundingClientRect(),
	        iFramePosition = messageData.iframe.getBoundingClientRect();
	
	      return JSON.stringify({
	        iframeHeight: iFramePosition.height,
	        iframeWidth: iFramePosition.width,
	        clientHeight: Math.max(
	          document.documentElement.clientHeight,
	          window.innerHeight || 0
	        ),
	        clientWidth: Math.max(
	          document.documentElement.clientWidth,
	          window.innerWidth || 0
	        ),
	        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
	        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
	        scrollTop: window.pageYOffset,
	        scrollLeft: window.pageXOffset
	      });
	    }
	
	    function sendPageInfoToIframe(iframe, iframeId) {
	      function debouncedTrigger() {
	        trigger(
	          'Send Page Info',
	          'pageInfo:' + getPageInfo(),
	          iframe,
	          iframeId
	        );
	      }
	      debounceFrameEvents(debouncedTrigger, 32, iframeId);
	    }
	
	    function startPageInfoMonitor() {
	      function setListener(type, func) {
	        function sendPageInfo() {
	          if (settings[id]) {
	            sendPageInfoToIframe(settings[id].iframe, id);
	          } else {
	            stop();
	          }
	        }
	
	        ['scroll', 'resize'].forEach(function(evt) {
	          log(id, type + evt + ' listener for sendPageInfo');
	          func(window, evt, sendPageInfo);
	        });
	      }
	
	      function stop() {
	        setListener('Remove ', removeEventListener);
	      }
	
	      function start() {
	        setListener('Add ', addEventListener);
	      }
	
	      var id = iframeId; //Create locally scoped copy of iFrame ID
	
	      start();
	
	      if (settings[id]) {
	        settings[id].stopPageInfo = stop;
	      }
	    }
	
	    function stopPageInfoMonitor() {
	      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
	        settings[iframeId].stopPageInfo();
	        delete settings[iframeId].stopPageInfo;
	      }
	    }
	
	    function checkIFrameExists() {
	      var retBool = true;
	
	      if (null === messageData.iframe) {
	        warn(iframeId, 'IFrame (' + messageData.id + ') not found');
	        retBool = false;
	      }
	      return retBool;
	    }
	
	    function getElementPosition(target) {
	      var iFramePosition = target.getBoundingClientRect();
	
	      getPagePosition(iframeId);
	
	      return {
	        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
	        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
	      };
	    }
	
	    function scrollRequestFromChild(addOffset) {
	      /* istanbul ignore next */ //Not testable in Karma
	      function reposition() {
	        pagePosition = newPosition;
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function calcOffset() {
	        return {
	          x: Number(messageData.width) + offset.x,
	          y: Number(messageData.height) + offset.y
	        };
	      }
	
	      function scrollParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
	            newPosition.x,
	            newPosition.y
	          );
	        } else {
	          warn(
	            iframeId,
	            'Unable to scroll to requested position, window.parentIFrame not found'
	          );
	        }
	      }
	
	      var offset = addOffset
	          ? getElementPosition(messageData.iframe)
	          : { x: 0, y: 0 },
	        newPosition = calcOffset();
	
	      log(
	        iframeId,
	        'Reposition requested from iFrame (offset x:' +
	          offset.x +
	          ' y:' +
	          offset.y +
	          ')'
	      );
	
	      if (window.top !== window.self) {
	        scrollParent();
	      } else {
	        reposition();
	      }
	    }
	
	    function scrollTo() {
	      if (false !== callback('scrollCallback', pagePosition)) {
	        setPagePosition(iframeId);
	      } else {
	        unsetPagePosition();
	      }
	    }
	
	    function findTarget(location) {
	      function jumpToTarget() {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          iframeId,
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        pagePosition = {
	          x: jumpPosition.x,
	          y: jumpPosition.y
	        };
	
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function jumpToParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame.moveToAnchor(hash);
	        } else {
	          log(
	            iframeId,
	            'In page link #' +
	              hash +
	              ' not found and window.parentIFrame not found'
	          );
	        }
	      }
	
	      var hash = location.split('#')[1] || '',
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (target) {
	        jumpToTarget();
	      } else if (window.top !== window.self) {
	        jumpToParent();
	      } else {
	        log(iframeId, 'In page link #' + hash + ' not found');
	      }
	    }
	
	    function callback(funcName, val) {
	      return chkCallback(iframeId, funcName, val);
	    }
	
	    function actionMsg() {
	      if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
	
	      switch (messageData.type) {
	        case 'close':
	          if (settings[iframeId].closeRequestCallback)
	            chkCallback(
	              iframeId,
	              'closeRequestCallback',
	              settings[iframeId].iframe
	            );
	          else closeIFrame(messageData.iframe);
	          break;
	        case 'message':
	          forwardMsgFromIFrame(getMsgBody(6));
	          break;
	        case 'scrollTo':
	          scrollRequestFromChild(false);
	          break;
	        case 'scrollToOffset':
	          scrollRequestFromChild(true);
	          break;
	        case 'pageInfo':
	          sendPageInfoToIframe(
	            settings[iframeId] && settings[iframeId].iframe,
	            iframeId
	          );
	          startPageInfoMonitor();
	          break;
	        case 'pageInfoStop':
	          stopPageInfoMonitor();
	          break;
	        case 'inPageLink':
	          findTarget(getMsgBody(9));
	          break;
	        case 'reset':
	          resetIFrame(messageData);
	          break;
	        case 'init':
	          resizeIFrame();
	          callback('initCallback', messageData.iframe);
	          break;
	        default:
	          resizeIFrame();
	      }
	    }
	
	    function hasSettings(iframeId) {
	      var retBool = true;
	
	      if (!settings[iframeId]) {
	        retBool = false;
	        warn(
	          messageData.type +
	            ' No settings for ' +
	            iframeId +
	            '. Message was: ' +
	            msg
	        );
	      }
	
	      return retBool;
	    }
	
	    function iFrameReadyMsgReceived() {
	      for (var iframeId in settings) {
	        trigger(
	          'iFrame requested init',
	          createOutgoingMsg(iframeId),
	          document.getElementById(iframeId),
	          iframeId
	        );
	      }
	    }
	
	    function firstRun() {
	      if (settings[iframeId]) {
	        settings[iframeId].firstRun = false;
	      }
	    }
	
	    function clearWarningTimeout() {
	      if (settings[iframeId]) {
	        clearTimeout(settings[iframeId].msgTimeout);
	        settings[iframeId].warningTimeout = 0;
	      }
	    }
	
	    var msg = event.data,
	      messageData = {},
	      iframeId = null;
	
	    if ('[iFrameResizerChild]Ready' === msg) {
	      iFrameReadyMsgReceived();
	    } else if (isMessageForUs()) {
	      messageData = processMsg();
	      iframeId = logId = messageData.id;
	      if (settings[iframeId]) {
	        settings[iframeId].loaded = true;
	      }
	
	      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
	        log(iframeId, 'Received: ' + msg);
	
	        if (checkIFrameExists() && isMessageFromIFrame()) {
	          actionMsg();
	        }
	      }
	    } else {
	      info(iframeId, 'Ignored: ' + msg);
	    }
	  }
	
	  function chkCallback(iframeId, funcName, val) {
	    var func = null,
	      retVal = null;
	
	    if (settings[iframeId]) {
	      func = settings[iframeId][funcName];
	
	      if ('function' === typeof func) {
	        retVal = func(val);
	      } else {
	        throw new TypeError(
	          funcName + ' on iFrame[' + iframeId + '] is not a function'
	        );
	      }
	    }
	
	    return retVal;
	  }
	
	  function removeIframeListeners(iframe) {
	    var iframeId = iframe.id;
	    delete settings[iframeId];
	  }
	
	  function closeIFrame(iframe) {
	    var iframeId = iframe.id;
	    log(iframeId, 'Removing iFrame: ' + iframeId);
	
	    try {
	      // Catch race condition error with React
	      if (iframe.parentNode) {
	        iframe.parentNode.removeChild(iframe);
	      }
	    } catch (e) {}
	
	    chkCallback(iframeId, 'closedCallback', iframeId);
	    log(iframeId, '--');
	    removeIframeListeners(iframe);
	  }
	
	  function getPagePosition(iframeId) {
	    if (null === pagePosition) {
	      pagePosition = {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	      log(
	        iframeId,
	        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	    }
	  }
	
	  function setPagePosition(iframeId) {
	    if (null !== pagePosition) {
	      window.scrollTo(pagePosition.x, pagePosition.y);
	      log(
	        iframeId,
	        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	      unsetPagePosition();
	    }
	  }
	
	  function unsetPagePosition() {
	    pagePosition = null;
	  }
	
	  function resetIFrame(messageData) {
	    function reset() {
	      setSize(messageData);
	      trigger('reset', 'reset', messageData.iframe, messageData.id);
	    }
	
	    log(
	      messageData.id,
	      'Size reset requested by ' +
	        ('init' === messageData.type ? 'host page' : 'iFrame')
	    );
	    getPagePosition(messageData.id);
	    syncResize(reset, messageData, 'reset');
	  }
	
	  function setSize(messageData) {
	    function setDimension(dimension) {
	      if (!messageData.id) {
	        log('undefined', 'messageData id not set');
	        return;
	      }
	      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
	      log(
	        messageData.id,
	        'IFrame (' +
	          iframeId +
	          ') ' +
	          dimension +
	          ' set to ' +
	          messageData[dimension] +
	          'px'
	      );
	    }
	
	    function chkZero(dimension) {
	      //FireFox sets dimension of hidden iFrames to zero.
	      //So if we detect that set up an event to check for
	      //when iFrame becomes visible.
	
	      /* istanbul ignore next */ //Not testable in PhantomJS
	      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
	        hiddenCheckEnabled = true;
	        log(iframeId, 'Hidden iFrame detected, creating visibility listener');
	        fixHiddenIFrames();
	      }
	    }
	
	    function processDimension(dimension) {
	      setDimension(dimension);
	      chkZero(dimension);
	    }
	
	    var iframeId = messageData.iframe.id;
	
	    if (settings[iframeId]) {
	      if (settings[iframeId].sizeHeight) {
	        processDimension('height');
	      }
	      if (settings[iframeId].sizeWidth) {
	        processDimension('width');
	      }
	    }
	  }
	
	  function syncResize(func, messageData, doNotSync) {
	    /* istanbul ignore if */ //Not testable in PhantomJS
	    if (doNotSync !== messageData.type && requestAnimationFrame) {
	      log(messageData.id, 'Requesting animation frame');
	      requestAnimationFrame(func);
	    } else {
	      func();
	    }
	  }
	
	  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
	    function postMessageToIFrame() {
	      var target = settings[id] && settings[id].targetOrigin;
	      log(
	        id,
	        '[' +
	          calleeMsg +
	          '] Sending msg to iframe[' +
	          id +
	          '] (' +
	          msg +
	          ') targetOrigin: ' +
	          target
	      );
	      iframe.contentWindow.postMessage(msgId + msg, target);
	    }
	
	    function iFrameNotFound() {
	      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
	    }
	
	    function chkAndSend() {
	      if (
	        iframe &&
	        'contentWindow' in iframe &&
	        null !== iframe.contentWindow
	      ) {
	        //Null test for PhantomJS
	        postMessageToIFrame();
	      } else {
	        iFrameNotFound();
	      }
	    }
	
	    function warnOnNoResponse() {
	      function warning() {
	        if (settings[id] && !settings[id].loaded && !errorShown) {
	          errorShown = true;
	          warn(
	            id,
	            'IFrame has not responded within ' +
	              settings[id].warningTimeout / 1000 +
	              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
	          );
	        }
	      }
	
	      if (
	        !!noResponseWarning &&
	        settings[id] &&
	        !!settings[id].warningTimeout
	      ) {
	        settings[id].msgTimeout = setTimeout(
	          warning,
	          settings[id].warningTimeout
	        );
	      }
	    }
	
	    var errorShown = false;
	
	    id = id || iframe.id;
	
	    if (settings[id]) {
	      chkAndSend();
	      warnOnNoResponse();
	    }
	  }
	
	  function createOutgoingMsg(iframeId) {
	    return (
	      iframeId +
	      ':' +
	      settings[iframeId].bodyMarginV1 +
	      ':' +
	      settings[iframeId].sizeWidth +
	      ':' +
	      settings[iframeId].log +
	      ':' +
	      settings[iframeId].interval +
	      ':' +
	      settings[iframeId].enablePublicMethods +
	      ':' +
	      settings[iframeId].autoResize +
	      ':' +
	      settings[iframeId].bodyMargin +
	      ':' +
	      settings[iframeId].heightCalculationMethod +
	      ':' +
	      settings[iframeId].bodyBackground +
	      ':' +
	      settings[iframeId].bodyPadding +
	      ':' +
	      settings[iframeId].tolerance +
	      ':' +
	      settings[iframeId].inPageLinks +
	      ':' +
	      settings[iframeId].resizeFrom +
	      ':' +
	      settings[iframeId].widthCalculationMethod
	    );
	  }
	
	  function setupIFrame(iframe, options) {
	    function setLimits() {
	      function addStyle(style) {
	        if (
	          Infinity !== settings[iframeId][style] &&
	          0 !== settings[iframeId][style]
	        ) {
	          iframe.style[style] = settings[iframeId][style] + 'px';
	          log(
	            iframeId,
	            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
	          );
	        }
	      }
	
	      function chkMinMax(dimension) {
	        if (
	          settings[iframeId]['min' + dimension] >
	          settings[iframeId]['max' + dimension]
	        ) {
	          throw new Error(
	            'Value for min' +
	              dimension +
	              ' can not be greater than max' +
	              dimension
	          );
	        }
	      }
	
	      chkMinMax('Height');
	      chkMinMax('Width');
	
	      addStyle('maxHeight');
	      addStyle('minHeight');
	      addStyle('maxWidth');
	      addStyle('minWidth');
	    }
	
	    function newId() {
	      var id = (options && options.id) || defaults.id + count++;
	      if (null !== document.getElementById(id)) {
	        id = id + count++;
	      }
	      return id;
	    }
	
	    function ensureHasId(iframeId) {
	      logId = iframeId;
	      if ('' === iframeId) {
	        iframe.id = iframeId = newId();
	        logEnabled = (options || {}).log;
	        logId = iframeId;
	        log(
	          iframeId,
	          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
	        );
	      }
	
	      return iframeId;
	    }
	
	    function setScrolling() {
	      log(
	        iframeId,
	        'IFrame scrolling ' +
	          (settings[iframeId] && settings[iframeId].scrolling
	            ? 'enabled'
	            : 'disabled') +
	          ' for ' +
	          iframeId
	      );
	      iframe.style.overflow =
	        false === (settings[iframeId] && settings[iframeId].scrolling)
	          ? 'hidden'
	          : 'auto';
	      switch (settings[iframeId] && settings[iframeId].scrolling) {
	        case 'omit':
	          break;
	        case true:
	          iframe.scrolling = 'yes';
	          break;
	        case false:
	          iframe.scrolling = 'no';
	          break;
	        default:
	          iframe.scrolling = settings[iframeId]
	            ? settings[iframeId].scrolling
	            : 'no';
	      }
	    }
	
	    //The V1 iFrame script expects an int, where as in V2 expects a CSS
	    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
	    //and then convert V2 to a string PX value.
	    function setupBodyMarginValues() {
	      if (
	        'number' ===
	          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
	        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
	      ) {
	        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
	        settings[iframeId].bodyMargin =
	          '' + settings[iframeId].bodyMargin + 'px';
	      }
	    }
	
	    function checkReset() {
	      // Reduce scope of firstRun to function, because IE8's JS execution
	      // context stack is borked and this value gets externally
	      // changed midway through running this function!!!
	      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
	        resetRequertMethod =
	          settings[iframeId] &&
	          settings[iframeId].heightCalculationMethod in resetRequiredMethods;
	
	      if (!firstRun && resetRequertMethod) {
	        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' });
	      }
	    }
	
	    function setupIFrameObject() {
	      if (Function.prototype.bind && settings[iframeId]) {
	        //Ignore unpolyfilled IE8.
	        settings[iframeId].iframe.iFrameResizer = {
	          close: closeIFrame.bind(null, settings[iframeId].iframe),
	
	          removeListeners: removeIframeListeners.bind(
	            null,
	            settings[iframeId].iframe
	          ),
	
	          resize: trigger.bind(
	            null,
	            'Window resize',
	            'resize',
	            settings[iframeId].iframe
	          ),
	
	          moveToAnchor: function(anchor) {
	            trigger(
	              'Move to anchor',
	              'moveToAnchor:' + anchor,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          },
	
	          sendMessage: function(message) {
	            message = JSON.stringify(message);
	            trigger(
	              'Send Message',
	              'message:' + message,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          }
	        };
	      }
	    }
	
	    //We have to call trigger twice, as we can not be sure if all
	    //iframes have completed loading when this code runs. The
	    //event listener also catches the page changing in the iFrame.
	    function init(msg) {
	      function iFrameLoaded() {
	        trigger('iFrame.onload', msg, iframe, undefined, true);
	        checkReset();
	      }
	
	      function createDestroyObserver(MutationObserver) {
	        if (!iframe.parentNode) {
	          return;
	        }
	
	        var destroyObserver = new MutationObserver(function (mutations) {
	          mutations.forEach(function (mutation) {
	            var removedNodes = Array.prototype.slice.call(mutation.removedNodes); // Transform NodeList into an Array
	            removedNodes.forEach(function (removedNode) {
	              if (removedNode === iframe) {
	                closeIFrame(iframe);
	              }
	            });
	          });
	        });
	        destroyObserver.observe(iframe.parentNode, {
	          childList: true
	        });
	      }
	
	      var MutationObserver = getMutationObserver();
	      if (MutationObserver) {
	        createDestroyObserver(MutationObserver);
	      }
	
	      addEventListener(iframe, 'load', iFrameLoaded);
	      trigger('init', msg, iframe, undefined, true);
	    }
	
	    function checkOptions(options) {
	      if ('object' !== typeof options) {
	        throw new TypeError('Options is not an object');
	      }
	    }
	
	    function copyOptions(options) {
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option)) {
	          settings[iframeId][option] = options.hasOwnProperty(option)
	            ? options[option]
	            : defaults[option];
	        }
	      }
	    }
	
	    function getTargetOrigin(remoteHost) {
	      return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
	    }
	
	    function processOptions(options) {
	      options = options || {};
	      settings[iframeId] = {
	        firstRun: true,
	        iframe: iframe,
	        remoteHost: iframe.src
	          .split('/')
	          .slice(0, 3)
	          .join('/')
	      };
	
	      checkOptions(options);
	      copyOptions(options);
	
	      if (settings[iframeId]) {
	        settings[iframeId].targetOrigin =
	          true === settings[iframeId].checkOrigin
	            ? getTargetOrigin(settings[iframeId].remoteHost)
	            : '*';
	      }
	    }
	
	    function beenHere() {
	      return iframeId in settings && 'iFrameResizer' in iframe;
	    }
	
	    var iframeId = ensureHasId(iframe.id);
	
	    if (!beenHere()) {
	      processOptions(options);
	      setScrolling();
	      setLimits();
	      setupBodyMarginValues();
	      init(createOutgoingMsg(iframeId));
	      setupIFrameObject();
	    } else {
	      warn(iframeId, 'Ignored iFrame, already setup.');
	    }
	  }
	
	  function debouce(fn, time) {
	    if (null === timer) {
	      timer = setTimeout(function() {
	        timer = null;
	        fn();
	      }, time);
	    }
	  }
	
	  var frameTimer = {};
	  function debounceFrameEvents(fn, time, frameId) {
	    if (!frameTimer[frameId]) {
	      frameTimer[frameId] = setTimeout(function() {
	        frameTimer[frameId] = null;
	        fn();
	      }, time);
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function fixHiddenIFrames() {
	    function checkIFrames() {
	      function checkIFrame(settingId) {
	        function chkDimension(dimension) {
	          return (
	            '0px' ===
	            (settings[settingId] && settings[settingId].iframe.style[dimension])
	          );
	        }
	
	        function isVisible(el) {
	          return null !== el.offsetParent;
	        }
	
	        if (
	          settings[settingId] &&
	          isVisible(settings[settingId].iframe) &&
	          (chkDimension('height') || chkDimension('width'))
	        ) {
	          trigger(
	            'Visibility change',
	            'resize',
	            settings[settingId].iframe,
	            settingId
	          );
	        }
	      }
	
	      for (var settingId in settings) {
	        checkIFrame(settingId);
	      }
	    }
	
	    function mutationObserved(mutations) {
	      log(
	        'window',
	        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	      debouce(checkIFrames, 16);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        },
	        observer = new MutationObserver(mutationObserved);
	
	      observer.observe(target, config);
	    }
	
	    var MutationObserver = getMutationObserver();
	    if (MutationObserver) {
	      createMutationObserver();
	    }
	  }
	
	  function resizeIFrames(event) {
	    function resize() {
	      sendTriggerMsg('Window ' + event, 'resize');
	    }
	
	    log('window', 'Trigger event: ' + event);
	    debouce(resize, 16);
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function tabVisible() {
	    function resize() {
	      sendTriggerMsg('Tab Visable', 'resize');
	    }
	
	    if ('hidden' !== document.visibilityState) {
	      log('document', 'Trigger event: Visiblity change');
	      debouce(resize, 16);
	    }
	  }
	
	  function sendTriggerMsg(eventName, event) {
	    function isIFrameResizeEnabled(iframeId) {
	      return (
	        settings[iframeId] &&
	        'parent' === settings[iframeId].resizeFrom &&
	        settings[iframeId].autoResize &&
	        !settings[iframeId].firstRun
	      );
	    }
	
	    for (var iframeId in settings) {
	      if (isIFrameResizeEnabled(iframeId)) {
	        trigger(eventName, event, document.getElementById(iframeId), iframeId);
	      }
	    }
	  }
	
	  function setupEventListeners() {
	    addEventListener(window, 'message', iFrameListener);
	
	    addEventListener(window, 'resize', function() {
	      resizeIFrames('resize');
	    });
	
	    addEventListener(document, 'visibilitychange', tabVisible);
	    addEventListener(document, '-webkit-visibilitychange', tabVisible); //Andriod 4.4
	    addEventListener(window, 'focusin', function() {
	      resizeIFrames('focus');
	    }); //IE8-9
	    addEventListener(window, 'focus', function() {
	      resizeIFrames('focus');
	    });
	  }
	
	  function factory() {
	    function init(options, element) {
	      function chkType() {
	        if (!element.tagName) {
	          throw new TypeError('Object is not a valid DOM element');
	        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
	          throw new TypeError(
	            'Expected <IFRAME> tag, found <' + element.tagName + '>'
	          );
	        }
	      }
	
	      if (element) {
	        chkType();
	        setupIFrame(element, options);
	        iFrames.push(element);
	      }
	    }
	
	    function warnDeprecatedOptions(options) {
	      if (options && options.enablePublicMethods) {
	        warn(
	          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
	        );
	      }
	    }
	
	    var iFrames;
	
	    setupRequestAnimationFrame();
	    setupEventListeners();
	
	    return function iFrameResizeF(options, target) {
	      iFrames = []; //Only return iFrames past in on this call
	
	      warnDeprecatedOptions(options);
	
	      switch (typeof target) {
	        case 'undefined':
	        case 'string':
	          Array.prototype.forEach.call(
	            document.querySelectorAll(target || 'iframe'),
	            init.bind(undefined, options)
	          );
	          break;
	        case 'object':
	          init(options, target);
	          break;
	        default:
	          throw new TypeError('Unexpected data type (' + typeof target + ')');
	      }
	
	      return iFrames;
	    };
	  }
	
	  function createJQueryPublicMethod($) {
	    if (!$.fn) {
	      info('', 'Unable to bind to jQuery, it is not fully loaded.');
	    } else if (!$.fn.iFrameResize) {
	      $.fn.iFrameResize = function $iFrameResizeF(options) {
	        function init(index, element) {
	          setupIFrame(element, options);
	        }
	
	        return this.filter('iframe')
	          .each(init)
	          .end();
	      };
	    }
	  }
	
	  if (window.jQuery) {
	    createJQueryPublicMethod(window.jQuery);
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module.exports === 'object') {
	    //Node for browserfy
	    module.exports = factory();
	  }
	  window.iFrameResize = window.iFrameResize || factory();
	})();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Ian Caunce - ian@hallnet.co.uk
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var autoResize = true,
	    base = 10,
	    bodyBackground = '',
	    bodyMargin = 0,
	    bodyMarginStr = '',
	    bodyObserver = null,
	    bodyPadding = '',
	    calculateWidth = false,
	    doubleEventList = { resize: 1, click: 1 },
	    eventCancelTimer = 128,
	    firstRun = true,
	    height = 1,
	    heightCalcModeDefault = 'bodyOffset',
	    heightCalcMode = heightCalcModeDefault,
	    initLock = true,
	    initMsg = '',
	    inPageLinks = {},
	    interval = 32,
	    intervalTimer = null,
	    logging = false,
	    msgID = '[iFrameSizer]', //Must match host page msg ID
	    msgIdLen = msgID.length,
	    myID = '',
	    observer = null,
	    resetRequiredMethods = {
	      max: 1,
	      min: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    resizeFrom = 'child',
	    sendPermit = true,
	    target = window.parent,
	    targetOriginDefault = '*',
	    tolerance = 0,
	    triggerLocked = false,
	    triggerLockedTimer = null,
	    throttledTimer = 16,
	    width = 1,
	    widthCalcModeDefault = 'scroll',
	    widthCalcMode = widthCalcModeDefault,
	    win = window,
	    messageCallback = function() {
	      warn('MessageCallback function not defined');
	    },
	    readyCallback = function() {},
	    pageInfoCallback = function() {},
	    customCalcMethods = {
	      height: function() {
	        warn('Custom height calculation function not defined');
	        return document.documentElement.offsetHeight;
	      },
	      width: function() {
	        warn('Custom width calculation function not defined');
	        return document.body.scrollWidth;
	      }
	    },
	    eventHandlersByName = {},
	    passiveSupported = false,
	    onceSupported = false;
	
	  function noop() {}
	
	  try {
	    var options = Object.create(
	      {},
	      {
	        passive: {
	          get: function() {
	            passiveSupported = true;
	          }
	        },
	        once: {
	          get: function() {
	            onceSupported = true;
	          }
	        }
	      }
	    );
	    window.addEventListener('test', noop, options);
	    window.removeEventListener('test', noop, options);
	  } catch (e) {
	    /* */
	  }
	
	  function addEventListener(el, evt, func, options) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('addEventListener' in window) {
	      el.addEventListener(evt, func, passiveSupported ? options || {} : false);
	    } else if ('attachEvent' in window) {
	      //IE
	      el.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  //Based on underscore.js
	  function throttle(func) {
	    var context,
	      args,
	      result,
	      timeout = null,
	      previous = 0,
	      later = function() {
	        previous = getNow();
	        timeout = null;
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = args = null;
	        }
	      };
	
	    return function() {
	      var now = getNow();
	
	      if (!previous) {
	        previous = now;
	      }
	
	      var remaining = throttledTimer - (now - previous);
	
	      context = this;
	      args = arguments;
	
	      if (remaining <= 0 || remaining > throttledTimer) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	
	        previous = now;
	        result = func.apply(context, args);
	
	        if (!timeout) {
	          context = args = null;
	        }
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	
	      return result;
	    };
	  }
	
	  var getNow =
	    Date.now ||
	    function() {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      return new Date().getTime();
	    };
	
	  function formatLogMsg(msg) {
	    return msgID + '[' + myID + ']' + ' ' + msg;
	  }
	
	  function log(msg) {
	    if (logging && 'object' === typeof window.console) {
	      console.log(formatLogMsg(msg));
	    }
	  }
	
	  function warn(msg) {
	    if ('object' === typeof window.console) {
	      console.warn(formatLogMsg(msg));
	    }
	  }
	
	  function init() {
	    readDataFromParent();
	    log('Initialising iFrame (' + location.href + ')');
	    readDataFromPage();
	    setMargin();
	    setBodyStyle('background', bodyBackground);
	    setBodyStyle('padding', bodyPadding);
	    injectClearFixIntoBodyElement();
	    checkHeightMode();
	    checkWidthMode();
	    stopInfiniteResizingOfIFrame();
	    setupPublicMethods();
	    startEventListeners();
	    inPageLinks = setupInPageLinks();
	    sendSize('init', 'Init message from host page');
	    readyCallback();
	  }
	
	  function readDataFromParent() {
	    function strBool(str) {
	      return 'true' === str ? true : false;
	    }
	
	    var data = initMsg.substr(msgIdLen).split(':');
	
	    myID = data[0];
	    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; //For V1 compatibility
	    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
	    logging = undefined !== data[3] ? strBool(data[3]) : logging;
	    interval = undefined !== data[4] ? Number(data[4]) : interval;
	    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
	    bodyMarginStr = data[7];
	    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
	    bodyBackground = data[9];
	    bodyPadding = data[10];
	    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
	    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
	    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
	    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
	  }
	
	  function readDataFromPage() {
	    function readData() {
	      var data = window.iFrameResizer;
	
	      log('Reading data from page: ' + JSON.stringify(data));
	
	      messageCallback =
	        'messageCallback' in data ? data.messageCallback : messageCallback;
	      readyCallback =
	        'readyCallback' in data ? data.readyCallback : readyCallback;
	      targetOriginDefault =
	        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
	      heightCalcMode =
	        'heightCalculationMethod' in data
	          ? data.heightCalculationMethod
	          : heightCalcMode;
	      widthCalcMode =
	        'widthCalculationMethod' in data
	          ? data.widthCalculationMethod
	          : widthCalcMode;
	    }
	
	    function setupCustomCalcMethods(calcMode, calcFunc) {
	      if ('function' === typeof calcMode) {
	        log('Setup custom ' + calcFunc + 'CalcMethod');
	        customCalcMethods[calcFunc] = calcMode;
	        calcMode = 'custom';
	      }
	
	      return calcMode;
	    }
	
	    if (
	      'iFrameResizer' in window &&
	      Object === window.iFrameResizer.constructor
	    ) {
	      readData();
	      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
	      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
	    }
	
	    log('TargetOrigin for parent set to: ' + targetOriginDefault);
	  }
	
	  function chkCSS(attr, value) {
	    if (-1 !== value.indexOf('-')) {
	      warn('Negative CSS value ignored for ' + attr);
	      value = '';
	    }
	    return value;
	  }
	
	  function setBodyStyle(attr, value) {
	    if (undefined !== value && '' !== value && 'null' !== value) {
	      document.body.style[attr] = value;
	      log('Body ' + attr + ' set to "' + value + '"');
	    }
	  }
	
	  function setMargin() {
	    //If called via V1 script, convert bodyMargin from int to str
	    if (undefined === bodyMarginStr) {
	      bodyMarginStr = bodyMargin + 'px';
	    }
	
	    setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
	  }
	
	  function stopInfiniteResizingOfIFrame() {
	    document.documentElement.style.height = '';
	    document.body.style.height = '';
	    log('HTML & body height set to "auto"');
	  }
	
	  function manageTriggerEvent(options) {
	    var listener = {
	      add: function(eventName) {
	        function handleEvent() {
	          sendSize(options.eventName, options.eventType);
	        }
	
	        eventHandlersByName[eventName] = handleEvent;
	
	        addEventListener(window, eventName, handleEvent, { passive: true });
	      },
	      remove: function(eventName) {
	        var handleEvent = eventHandlersByName[eventName];
	        delete eventHandlersByName[eventName];
	
	        removeEventListener(window, eventName, handleEvent);
	      }
	    };
	
	    if (options.eventNames && Array.prototype.map) {
	      options.eventName = options.eventNames[0];
	      options.eventNames.map(listener[options.method]);
	    } else {
	      listener[options.method](options.eventName);
	    }
	
	    log(
	      capitalizeFirstLetter(options.method) +
	        ' event listener: ' +
	        options.eventType
	    );
	  }
	
	  function manageEventListeners(method) {
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Start',
	      eventNames: ['animationstart', 'webkitAnimationStart']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Iteration',
	      eventNames: ['animationiteration', 'webkitAnimationIteration']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation End',
	      eventNames: ['animationend', 'webkitAnimationEnd']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Input',
	      eventName: 'input'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Up',
	      eventName: 'mouseup'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Down',
	      eventName: 'mousedown'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Orientation Change',
	      eventName: 'orientationchange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Print',
	      eventName: ['afterprint', 'beforeprint']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Ready State Change',
	      eventName: 'readystatechange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Start',
	      eventName: 'touchstart'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch End',
	      eventName: 'touchend'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Cancel',
	      eventName: 'touchcancel'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Start',
	      eventNames: [
	        'transitionstart',
	        'webkitTransitionStart',
	        'MSTransitionStart',
	        'oTransitionStart',
	        'otransitionstart'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Iteration',
	      eventNames: [
	        'transitioniteration',
	        'webkitTransitionIteration',
	        'MSTransitionIteration',
	        'oTransitionIteration',
	        'otransitioniteration'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition End',
	      eventNames: [
	        'transitionend',
	        'webkitTransitionEnd',
	        'MSTransitionEnd',
	        'oTransitionEnd',
	        'otransitionend'
	      ]
	    });
	    if ('child' === resizeFrom) {
	      manageTriggerEvent({
	        method: method,
	        eventType: 'IFrame Resized',
	        eventName: 'resize'
	      });
	    }
	  }
	
	  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
	    if (calcModeDefault !== calcMode) {
	      if (!(calcMode in modes)) {
	        warn(
	          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
	        );
	        calcMode = calcModeDefault;
	      }
	      log(type + ' calculation method set to "' + calcMode + '"');
	    }
	
	    return calcMode;
	  }
	
	  function checkHeightMode() {
	    heightCalcMode = checkCalcMode(
	      heightCalcMode,
	      heightCalcModeDefault,
	      getHeight,
	      'height'
	    );
	  }
	
	  function checkWidthMode() {
	    widthCalcMode = checkCalcMode(
	      widthCalcMode,
	      widthCalcModeDefault,
	      getWidth,
	      'width'
	    );
	  }
	
	  function startEventListeners() {
	    if (true === autoResize) {
	      manageEventListeners('add');
	      setupMutationObserver();
	    } else {
	      log('Auto Resize disabled');
	    }
	  }
	
	  function stopMsgsToParent() {
	    log('Disable outgoing messages');
	    sendPermit = false;
	  }
	
	  function removeMsgListener() {
	    log('Remove event listener: Message');
	    removeEventListener(window, 'message', receiver);
	  }
	
	  function disconnectMutationObserver() {
	    if (null !== bodyObserver) {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      bodyObserver.disconnect();
	    }
	  }
	
	  function stopEventListeners() {
	    manageEventListeners('remove');
	    disconnectMutationObserver();
	    clearInterval(intervalTimer);
	  }
	
	  function teardown() {
	    stopMsgsToParent();
	    removeMsgListener();
	    if (true === autoResize) stopEventListeners();
	  }
	
	  function injectClearFixIntoBodyElement() {
	    var clearFix = document.createElement('div');
	    clearFix.style.clear = 'both';
	    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
	    document.body.appendChild(clearFix);
	  }
	
	  function setupInPageLinks() {
	    function getPagePosition() {
	      return {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	    }
	
	    function getElementPosition(el) {
	      var elPosition = el.getBoundingClientRect(),
	        pagePosition = getPagePosition();
	
	      return {
	        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
	        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
	      };
	    }
	
	    function findTarget(location) {
	      function jumpToTarget(target) {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      }
	
	      var hash = location.split('#')[1] || location, //Remove # if present
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (undefined !== target) {
	        jumpToTarget(target);
	      } else {
	        log(
	          'In page link (#' +
	            hash +
	            ') not found in iFrame, so sending to parent'
	        );
	        sendMsg(0, 0, 'inPageLink', '#' + hash);
	      }
	    }
	
	    function checkLocationHash() {
	      if ('' !== location.hash && '#' !== location.hash) {
	        findTarget(location.href);
	      }
	    }
	
	    function bindAnchors() {
	      function setupLink(el) {
	        function linkClicked(e) {
	          e.preventDefault();
	
	          /*jshint validthis:true */
	          findTarget(this.getAttribute('href'));
	        }
	
	        if ('#' !== el.getAttribute('href')) {
	          addEventListener(el, 'click', linkClicked);
	        }
	      }
	
	      Array.prototype.forEach.call(
	        document.querySelectorAll('a[href^="#"]'),
	        setupLink
	      );
	    }
	
	    function bindLocationHash() {
	      addEventListener(window, 'hashchange', checkLocationHash);
	    }
	
	    function initCheck() {
	      //check if page loaded with location hash after init resize
	      setTimeout(checkLocationHash, eventCancelTimer);
	    }
	
	    function enableInPageLinks() {
	      /* istanbul ignore else */ // Not testable in phantonJS
	      if (Array.prototype.forEach && document.querySelectorAll) {
	        log('Setting up location.hash handlers');
	        bindAnchors();
	        bindLocationHash();
	        initCheck();
	      } else {
	        warn(
	          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
	        );
	      }
	    }
	
	    if (inPageLinks.enable) {
	      enableInPageLinks();
	    } else {
	      log('In page linking not enabled');
	    }
	
	    return {
	      findTarget: findTarget
	    };
	  }
	
	  function setupPublicMethods() {
	    log('Enable public methods');
	
	    win.parentIFrame = {
	      autoResize: function autoResizeF(resize) {
	        if (true === resize && false === autoResize) {
	          autoResize = true;
	          startEventListeners();
	          //sendSize('autoResize','Auto Resize enabled');
	        } else if (false === resize && true === autoResize) {
	          autoResize = false;
	          stopEventListeners();
	        }
	
	        return autoResize;
	      },
	
	      close: function closeF() {
	        sendMsg(0, 0, 'close');
	        teardown();
	      },
	
	      getId: function getIdF() {
	        return myID;
	      },
	
	      getPageInfo: function getPageInfoF(callback) {
	        if ('function' === typeof callback) {
	          pageInfoCallback = callback;
	          sendMsg(0, 0, 'pageInfo');
	        } else {
	          pageInfoCallback = function() {};
	          sendMsg(0, 0, 'pageInfoStop');
	        }
	      },
	
	      moveToAnchor: function moveToAnchorF(hash) {
	        inPageLinks.findTarget(hash);
	      },
	
	      reset: function resetF() {
	        resetIFrame('parentIFrame.reset');
	      },
	
	      scrollTo: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      scrollToOffset: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      sendMessage: function sendMessageF(msg, targetOrigin) {
	        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
	      },
	
	      setHeightCalculationMethod: function setHeightCalculationMethodF(
	        heightCalculationMethod
	      ) {
	        heightCalcMode = heightCalculationMethod;
	        checkHeightMode();
	      },
	
	      setWidthCalculationMethod: function setWidthCalculationMethodF(
	        widthCalculationMethod
	      ) {
	        widthCalcMode = widthCalculationMethod;
	        checkWidthMode();
	      },
	
	      setTargetOrigin: function setTargetOriginF(targetOrigin) {
	        log('Set targetOrigin: ' + targetOrigin);
	        targetOriginDefault = targetOrigin;
	      },
	
	      size: function sizeF(customHeight, customWidth) {
	        var valString =
	          '' +
	          (customHeight ? customHeight : '') +
	          (customWidth ? ',' + customWidth : '');
	        //lockTrigger();
	        sendSize(
	          'size',
	          'parentIFrame.size(' + valString + ')',
	          customHeight,
	          customWidth
	        );
	      }
	    };
	  }
	
	  function initInterval() {
	    if (0 !== interval) {
	      log('setInterval: ' + interval + 'ms');
	      intervalTimer = setInterval(function() {
	        sendSize('interval', 'setInterval: ' + interval);
	      }, Math.abs(interval));
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function setupBodyMutationObserver() {
	    function addImageLoadListners(mutation) {
	      function addImageLoadListener(element) {
	        if (false === element.complete) {
	          log('Attach listeners to ' + element.src);
	          element.addEventListener('load', imageLoaded, false);
	          element.addEventListener('error', imageError, false);
	          elements.push(element);
	        }
	      }
	
	      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	        addImageLoadListener(mutation.target);
	      } else if (mutation.type === 'childList') {
	        Array.prototype.forEach.call(
	          mutation.target.querySelectorAll('img'),
	          addImageLoadListener
	        );
	      }
	    }
	
	    function removeFromArray(element) {
	      elements.splice(elements.indexOf(element), 1);
	    }
	
	    function removeImageLoadListener(element) {
	      log('Remove listeners from ' + element.src);
	      element.removeEventListener('load', imageLoaded, false);
	      element.removeEventListener('error', imageError, false);
	      removeFromArray(element);
	    }
	
	    function imageEventTriggered(event, type, typeDesc) {
	      removeImageLoadListener(event.target);
	      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
	    }
	
	    function imageLoaded(event) {
	      imageEventTriggered(event, 'imageLoad', 'Image loaded');
	    }
	
	    function imageError(event) {
	      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
	    }
	
	    function mutationObserved(mutations) {
	      sendSize(
	        'mutationObserver',
	        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	
	      //Deal with WebKit asyncing image loading when tags are injected into the page
	      mutations.forEach(addImageLoadListners);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        };
	
	      observer = new MutationObserver(mutationObserved);
	
	      log('Create body MutationObserver');
	      observer.observe(target, config);
	
	      return observer;
	    }
	
	    var elements = [],
	      MutationObserver =
	        window.MutationObserver || window.WebKitMutationObserver,
	      observer = createMutationObserver();
	
	    return {
	      disconnect: function() {
	        if ('disconnect' in observer) {
	          log('Disconnect body MutationObserver');
	          observer.disconnect();
	          elements.forEach(removeImageLoadListener);
	        }
	      }
	    };
	  }
	
	  function setupMutationObserver() {
	    var forceIntervalTimer = 0 > interval; // Not testable in PhantomJS
	
	    /* istanbul ignore if */ if (
	      window.MutationObserver ||
	      window.WebKitMutationObserver
	    ) {
	      if (forceIntervalTimer) {
	        initInterval();
	      } else {
	        bodyObserver = setupBodyMutationObserver();
	      }
	    } else {
	      log('MutationObserver not supported in this browser!');
	      initInterval();
	    }
	  }
	
	  // document.documentElement.offsetHeight is not reliable, so
	  // we have to jump through hoops to get a better value.
	  function getComputedStyle(prop, el) {
	    /* istanbul ignore next */ //Not testable in PhantomJS
	    function convertUnitsToPxForIE8(value) {
	      var PIXEL = /^\d+(px)?$/i;
	
	      if (PIXEL.test(value)) {
	        return parseInt(value, base);
	      }
	
	      var style = el.style.left,
	        runtimeStyle = el.runtimeStyle.left;
	
	      el.runtimeStyle.left = el.currentStyle.left;
	      el.style.left = value || 0;
	      value = el.style.pixelLeft;
	      el.style.left = style;
	      el.runtimeStyle.left = runtimeStyle;
	
	      return value;
	    }
	
	    var retVal = 0;
	    el = el || document.body; // Not testable in phantonJS
	
	    /* istanbul ignore else */ if (
	      'defaultView' in document &&
	      'getComputedStyle' in document.defaultView
	    ) {
	      retVal = document.defaultView.getComputedStyle(el, null);
	      retVal = null !== retVal ? retVal[prop] : 0;
	    } else {
	      //IE8
	      retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
	    }
	
	    return parseInt(retVal, base);
	  }
	
	  function chkEventThottle(timer) {
	    if (timer > throttledTimer / 2) {
	      throttledTimer = 2 * timer;
	      log('Event throttle increased to ' + throttledTimer + 'ms');
	    }
	  }
	
	  //Idea from https://github.com/guardian/iframe-messenger
	  function getMaxElement(side, elements) {
	    var elementsLength = elements.length,
	      elVal = 0,
	      maxVal = 0,
	      Side = capitalizeFirstLetter(side),
	      timer = getNow();
	
	    for (var i = 0; i < elementsLength; i++) {
	      elVal =
	        elements[i].getBoundingClientRect()[side] +
	        getComputedStyle('margin' + Side, elements[i]);
	      if (elVal > maxVal) {
	        maxVal = elVal;
	      }
	    }
	
	    timer = getNow() - timer;
	
	    log('Parsed ' + elementsLength + ' HTML elements');
	    log('Element position calculated in ' + timer + 'ms');
	
	    chkEventThottle(timer);
	
	    return maxVal;
	  }
	
	  function getAllMeasurements(dimention) {
	    return [
	      dimention.bodyOffset(),
	      dimention.bodyScroll(),
	      dimention.documentElementOffset(),
	      dimention.documentElementScroll()
	    ];
	  }
	
	  function getTaggedElements(side, tag) {
	    function noTaggedElementsFound() {
	      warn('No tagged elements (' + tag + ') found on page');
	      return document.querySelectorAll('body *');
	    }
	
	    var elements = document.querySelectorAll('[' + tag + ']');
	
	    if (0 === elements.length) noTaggedElementsFound();
	
	    return getMaxElement(side, elements);
	  }
	
	  function getAllElements() {
	    return document.querySelectorAll('body *');
	  }
	
	  var getHeight = {
	      bodyOffset: function getBodyOffsetHeight() {
	        return (
	          document.body.offsetHeight +
	          getComputedStyle('marginTop') +
	          getComputedStyle('marginBottom')
	        );
	      },
	
	      offset: function() {
	        return getHeight.bodyOffset(); //Backwards compatability
	      },
	
	      bodyScroll: function getBodyScrollHeight() {
	        return document.body.scrollHeight;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.height();
	      },
	
	      documentElementOffset: function getDEOffsetHeight() {
	        return document.documentElement.offsetHeight;
	      },
	
	      documentElementScroll: function getDEScrollHeight() {
	        return document.documentElement.scrollHeight;
	      },
	
	      max: function getMaxHeight() {
	        return Math.max.apply(null, getAllMeasurements(getHeight));
	      },
	
	      min: function getMinHeight() {
	        return Math.min.apply(null, getAllMeasurements(getHeight));
	      },
	
	      grow: function growHeight() {
	        return getHeight.max(); //Run max without the forced downsizing
	      },
	
	      lowestElement: function getBestHeight() {
	        return Math.max(
	          getHeight.bodyOffset() || getHeight.documentElementOffset(),
	          getMaxElement('bottom', getAllElements())
	        );
	      },
	
	      taggedElement: function getTaggedElementsHeight() {
	        return getTaggedElements('bottom', 'data-iframe-height');
	      }
	    },
	    getWidth = {
	      bodyScroll: function getBodyScrollWidth() {
	        return document.body.scrollWidth;
	      },
	
	      bodyOffset: function getBodyOffsetWidth() {
	        return document.body.offsetWidth;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.width();
	      },
	
	      documentElementScroll: function getDEScrollWidth() {
	        return document.documentElement.scrollWidth;
	      },
	
	      documentElementOffset: function getDEOffsetWidth() {
	        return document.documentElement.offsetWidth;
	      },
	
	      scroll: function getMaxWidth() {
	        return Math.max(
	          getWidth.bodyScroll(),
	          getWidth.documentElementScroll()
	        );
	      },
	
	      max: function getMaxWidth() {
	        return Math.max.apply(null, getAllMeasurements(getWidth));
	      },
	
	      min: function getMinWidth() {
	        return Math.min.apply(null, getAllMeasurements(getWidth));
	      },
	
	      rightMostElement: function rightMostElement() {
	        return getMaxElement('right', getAllElements());
	      },
	
	      taggedElement: function getTaggedElementsWidth() {
	        return getTaggedElements('right', 'data-iframe-width');
	      }
	    };
	
	  function sizeIFrame(
	    triggerEvent,
	    triggerEventDesc,
	    customHeight,
	    customWidth
	  ) {
	    function resizeIFrame() {
	      height = currentHeight;
	      width = currentWidth;
	
	      sendMsg(height, width, triggerEvent);
	    }
	
	    function isSizeChangeDetected() {
	      function checkTolarance(a, b) {
	        var retVal = Math.abs(a - b) <= tolerance;
	        return !retVal;
	      }
	
	      currentHeight =
	        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
	      currentWidth =
	        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
	
	      return (
	        checkTolarance(height, currentHeight) ||
	        (calculateWidth && checkTolarance(width, currentWidth))
	      );
	    }
	
	    function isForceResizableEvent() {
	      return !(triggerEvent in { init: 1, interval: 1, size: 1 });
	    }
	
	    function isForceResizableCalcMode() {
	      return (
	        heightCalcMode in resetRequiredMethods ||
	        (calculateWidth && widthCalcMode in resetRequiredMethods)
	      );
	    }
	
	    function logIgnored() {
	      log('No change in size detected');
	    }
	
	    function checkDownSizing() {
	      if (isForceResizableEvent() && isForceResizableCalcMode()) {
	        resetIFrame(triggerEventDesc);
	      } else if (!(triggerEvent in { interval: 1 })) {
	        logIgnored();
	      }
	    }
	
	    var currentHeight, currentWidth;
	
	    if (isSizeChangeDetected() || 'init' === triggerEvent) {
	      lockTrigger();
	      resizeIFrame();
	    } else {
	      checkDownSizing();
	    }
	  }
	
	  var sizeIFrameThrottled = throttle(sizeIFrame);
	
	  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
	    function recordTrigger() {
	      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
	        log('Trigger event: ' + triggerEventDesc);
	      }
	    }
	
	    function isDoubleFiredEvent() {
	      return triggerLocked && triggerEvent in doubleEventList;
	    }
	
	    if (!isDoubleFiredEvent()) {
	      recordTrigger();
	      if (triggerEvent === 'init') {
	        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
	      } else {
	        sizeIFrameThrottled(
	          triggerEvent,
	          triggerEventDesc,
	          customHeight,
	          customWidth
	        );
	      }
	    } else {
	      log('Trigger event cancelled: ' + triggerEvent);
	    }
	  }
	
	  function lockTrigger() {
	    if (!triggerLocked) {
	      triggerLocked = true;
	      log('Trigger event lock on');
	    }
	    clearTimeout(triggerLockedTimer);
	    triggerLockedTimer = setTimeout(function() {
	      triggerLocked = false;
	      log('Trigger event lock off');
	      log('--');
	    }, eventCancelTimer);
	  }
	
	  function triggerReset(triggerEvent) {
	    height = getHeight[heightCalcMode]();
	    width = getWidth[widthCalcMode]();
	
	    sendMsg(height, width, triggerEvent);
	  }
	
	  function resetIFrame(triggerEventDesc) {
	    var hcm = heightCalcMode;
	    heightCalcMode = heightCalcModeDefault;
	
	    log('Reset trigger event: ' + triggerEventDesc);
	    lockTrigger();
	    triggerReset('reset');
	
	    heightCalcMode = hcm;
	  }
	
	  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
	    function setTargetOrigin() {
	      if (undefined === targetOrigin) {
	        targetOrigin = targetOriginDefault;
	      } else {
	        log('Message targetOrigin: ' + targetOrigin);
	      }
	    }
	
	    function sendToParent() {
	      var size = height + ':' + width,
	        message =
	          myID +
	          ':' +
	          size +
	          ':' +
	          triggerEvent +
	          (undefined !== msg ? ':' + msg : '');
	
	      log('Sending message to host page (' + message + ')');
	      target.postMessage(msgID + message, targetOrigin);
	    }
	
	    if (true === sendPermit) {
	      setTargetOrigin();
	      sendToParent();
	    }
	  }
	
	  function receiver(event) {
	    var processRequestFromParent = {
	      init: function initFromParent() {
	        initMsg = event.data;
	        target = event.source;
	
	        init();
	        firstRun = false;
	        setTimeout(function() {
	          initLock = false;
	        }, eventCancelTimer);
	      },
	
	      reset: function resetFromParent() {
	        if (!initLock) {
	          log('Page size reset by host page');
	          triggerReset('resetPage');
	        } else {
	          log('Page reset ignored by init');
	        }
	      },
	
	      resize: function resizeFromParent() {
	        sendSize('resizeParent', 'Parent window requested size check');
	      },
	
	      moveToAnchor: function moveToAnchorF() {
	        inPageLinks.findTarget(getData());
	      },
	      inPageLink: function inPageLinkF() {
	        this.moveToAnchor();
	      }, //Backward compatability
	
	      pageInfo: function pageInfoFromParent() {
	        var msgBody = getData();
	        log('PageInfoFromParent called from parent: ' + msgBody);
	        pageInfoCallback(JSON.parse(msgBody));
	        log(' --');
	      },
	
	      message: function messageFromParent() {
	        var msgBody = getData();
	
	        log('MessageCallback called from parent: ' + msgBody);
	        messageCallback(JSON.parse(msgBody));
	        log(' --');
	      }
	    };
	
	    function isMessageForUs() {
	      return msgID === ('' + event.data).substr(0, msgIdLen); //''+ Protects against non-string messages
	    }
	
	    function getMessageType() {
	      return event.data.split(']')[1].split(':')[0];
	    }
	
	    function getData() {
	      return event.data.substr(event.data.indexOf(':') + 1);
	    }
	
	    function isMiddleTier() {
	      return (
	        (!(typeof module !== 'undefined' && module.exports) &&
	          'iFrameResize' in window) ||
	        ('jQuery' in window && 'iFrameResize' in window.jQuery.prototype)
	      );
	    }
	
	    function isInitMsg() {
	      //Test if this message is from a child below us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      return event.data.split(':')[2] in { true: 1, false: 1 };
	    }
	
	    function callFromParent() {
	      var messageType = getMessageType();
	
	      if (messageType in processRequestFromParent) {
	        processRequestFromParent[messageType]();
	      } else if (!isMiddleTier() && !isInitMsg()) {
	        warn('Unexpected message (' + event.data + ')');
	      }
	    }
	
	    function processMessage() {
	      if (false === firstRun) {
	        callFromParent();
	      } else if (isInitMsg()) {
	        processRequestFromParent.init();
	      } else {
	        log(
	          'Ignored message of type "' +
	            getMessageType() +
	            '". Received before initialization.'
	        );
	      }
	    }
	
	    if (isMessageForUs()) {
	      processMessage();
	    }
	  }
	
	  //Normally the parent kicks things off when it detects the iFrame has loaded.
	  //If this script is async-loaded, then tell parent page to retry init.
	  function chkLateLoaded() {
	    if ('loading' !== document.readyState) {
	      window.parent.postMessage('[iFrameResizerChild]Ready', '*');
	    }
	  }
	
	  addEventListener(window, 'message', receiver);
	  addEventListener(window, 'readystatechange', chkLateLoaded);
	  chkLateLoaded();
	
	  
	})();


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = floatLabelDirective;
	
	var _window = __webpack_require__(9);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @module directives/form/float-label
	 */
	
	/**
	 * Applies the correct class names to the field.
	 * @param {Event} [event=null] - The event object.
	 * @param {HTMLElement} [element=null] - The element context.
	 */
	function setState() {
	  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var field = element ? element : event.currentTarget;
	
	  /** Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	   * problem with the "keydown" event in that the key value is added to the field after the event has been
	   * called. This means the value of the field returned will be the previous value. The timeout ensures that
	   * the input happens before the value is checked. */
	  setTimeout(function (_) {
	
	    // Enhance the file input by outputting information about the selected file
	    if (field.matches('input[type="file"]')) {
	      var parent = field.parentNode;
	      var div = [].concat(_toConsumableArray(parent.children)).filter(function (child) {
	        return child.matches('div');
	      })[0];
	
	      if (div) {
	        var fileName = '';
	        if (field.files && field.files.length > 1) {
	          fileName = field.files.length + ' files selected';
	        } else {
	          fileName = field.value.split('\\').pop();
	        }
	
	        div.innerHTML = fileName;
	      }
	    }
	
	    // Class toggles.
	    var label = field.closest('[data-sw-float-label]');
	
	    // Set the field type as a class to the float label wrapper
	    label.classList.add('-type-' + field.tagName.toLowerCase());
	
	    // Is the element in focus?
	    label.classList.toggle('is-focused', event ? event.type == 'focus' || field.matches(':focus') : false);
	
	    /**
	     * Check if the fields value is an empty string. This works for select options that have an empty
	     * value. This can be exploited by creating an empty option, disabling it and setting it as the
	     * default. */
	    label.classList.toggle('is-filled', field.value.trim().length > 0);
	
	    // Only apply if browser supports field validation
	    label.classList.toggle('is-invalid', field.validity && !field.validity.valid);
	
	    /** Specifically for textarea's. This is useful so that the label can be hidden when the content is
	     * scrolled, so that the label and the fields text don't overlap and look ugly. */
	    label.classList.toggle('is-scrolled', field.scrollTop > 0);
	  });
	}
	
	/**
	 * Adds float label behaviour to marked fields.
	 */
	function floatLabelDirective() {
	
	  // Bind events to form inputs.
	  document.querySelectorAll('[data-sw-float-label]').forEach(function (element) {
	    element.querySelectorAll('input, select, textarea').forEach(function (input) {
	      (0, _window.bindEvents)(input, "focus blur change keyup keydown scroll", setState);
	      setState({}, input);
	    });
	  });
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = validatorDirective;
	
	var _pristinejs = __webpack_require__(25);
	
	var _pristinejs2 = _interopRequireDefault(_pristinejs);
	
	var _data = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Form validation using the PristineJS library.
	 * @module directives/form/validatorDirective
	 * @see https://github.com/sha256/Pristine
	 */
	
	/**
	 * Enhances forms with live validation.
	 */
	function validatorDirective() {
	
	  /**
	   * Set eneabled state of forms.
	   * @param {HTMLElement} form - The form to enable.
	   * @param {Booealn} enabled - The enabled state to set.
	   */
	  var setFormEnabled = function setFormEnabled(form, enabled) {
	    form.querySelectorAll('input, select, textarea').forEach(function (form) {
	      return form.readonly = !enabled;
	    });
	    form.querySelectorAll('button').forEach(function (form) {
	      return form.disabled = !enabled;
	    });
	    form.classList[!enabled ? 'add' : 'remove']('is-posting');
	  };
	
	  // Attach validators to forms
	  var forms = [].concat(_toConsumableArray(document.querySelectorAll('form[data-sw-validator]')));
	  if (forms.length > 0) forms.forEach(function (form) {
	    // Attach a validator to the form
	    (0, _data.putData)(form, 'validator', {
	
	      // Pristine validator
	      validator: new _pristinejs2.default(form, {
	        classTo: 'float-label',
	        errorTextParent: 'float-label',
	        errorClass: '-pristine-is-invalid',
	        successClass: '-pristine-is-valid',
	        errorTextClass: 'float-label_errors'
	      }, false),
	
	      // Initially not listening for form submits
	      isListening: false,
	
	      // Submit the form
	      runSubmission: function runSubmission() {
	        var _this = this;
	
	        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var preSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	
	        // Submit listener
	        var submitListener = function submitListener(event) {
	          return _this.runSubmission(event);
	        };
	
	        // Remove any server error messages
	        form.querySelectorAll('.-served-error').forEach(function (error) {
	          return error.remove();
	        });
	
	        // Check valid.
	        var valid = this.validator.validate();
	        if (valid) {
	
	          // Disable form
	          setFormEnabled(form, false);
	
	          // Enable on load
	          var target = form.target,
	              container = target ? document.querySelector('iframe[name="' + target + '"]') : document;
	          container.addEventListener('load', function () {
	            return setFormEnabled(form, true);
	          });
	
	          // Call this if it's there
	          if (preSubmit) preSubmit(event);
	
	          // Remove submit listener and post it
	          form.removeEventListener('submit', submitListener);
	          form.submit();
	        } else {
	
	          // reCaptcha is removed on first post, so we need to hook on a submit function
	          if (!this.isListening) form.addEventListener('submit', submitListener);
	          this.isListening = true;
	        }
	      }
	    });
	  });
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Pristine = factory());
	}(this, (function () { 'use strict';
	
	    var lang = {
	        required: "This field is required",
	        email: "This field requires a valid e-mail address",
	        number: "This field requires a number",
	        integer: "This field requires an integer value",
	        url: "This field requires a valid website URL",
	        tel: "This field requires a valid telephone number",
	        maxlength: "This fields length must be < ${1}",
	        minlength: "This fields length must be > ${1}",
	        min: "Minimum value for this field is ${1}",
	        max: "Maximum value for this field is ${1}",
	        pattern: "Please match the requested format"
	    };
	
	    function findAncestor(el, cls) {
	        while ((el = el.parentElement) && !el.classList.contains(cls)) {}
	        return el;
	    }
	
	    function tmpl(o) {
	        var _arguments = arguments;
	
	        return this.replace(/\${([^{}]*)}/g, function (a, b) {
	            return _arguments[b];
	        });
	    }
	
	    function groupedElemCount(input) {
	        return input.pristine.self.form.querySelectorAll('input[name="' + input.getAttribute('name') + '"]:checked').length;
	    }
	
	    function mergeConfig(obj1, obj2) {
	        for (var attr in obj2) {
	            if (!(attr in obj1)) {
	                obj1[attr] = obj2[attr];
	            }
	        }
	        return obj1;
	    }
	
	    function isFunction(obj) {
	        return !!(obj && obj.constructor && obj.call && obj.apply);
	    }
	
	    var defaultConfig = {
	        classTo: 'form-group',
	        errorClass: 'has-danger',
	        successClass: 'has-success',
	        errorTextParent: 'form-group',
	        errorTextTag: 'div',
	        errorTextClass: 'text-help'
	    };
	
	    var PRISTINE_ERROR = 'pristine-error';
	    var SELECTOR = "input:not([type^=hidden]):not([type^=submit]), select, textarea";
	    var ALLOWED_ATTRIBUTES = ["required", "min", "max", 'minlength', 'maxlength', 'pattern'];
	    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	    var validators = {};
	
	    var _ = function _(name, validator) {
	        validator.name = name;
	        if (!validator.msg) validator.msg = lang[name];
	        if (validator.priority === undefined) validator.priority = 1;
	        validators[name] = validator;
	    };
	
	    _('text', { fn: function fn(val) {
	            return true;
	        }, priority: 0 });
	    _('required', { fn: function fn(val) {
	            return this.type === 'radio' || this.type === 'checkbox' ? groupedElemCount(this) : val !== undefined && val !== '';
	        }, priority: 99, halt: true });
	    _('email', { fn: function fn(val) {
	            return !val || EMAIL_REGEX.test(val);
	        } });
	    _('number', { fn: function fn(val) {
	            return !val || !isNaN(parseFloat(val));
	        }, priority: 2 });
	    _('integer', { fn: function fn(val) {
	            return !val || /^\d+$/.test(val);
	        } });
	    _('minlength', { fn: function fn(val, length) {
	            return !val || val.length >= parseInt(length);
	        } });
	    _('maxlength', { fn: function fn(val, length) {
	            return !val || val.length <= parseInt(length);
	        } });
	    _('min', { fn: function fn(val, limit) {
	            return !val || (this.type === 'checkbox' ? groupedElemCount(this) >= parseInt(limit) : parseFloat(val) >= parseFloat(limit));
	        } });
	    _('max', { fn: function fn(val, limit) {
	            return !val || (this.type === 'checkbox' ? groupedElemCount(this) <= parseInt(limit) : parseFloat(val) <= parseFloat(limit));
	        } });
	    _('pattern', { fn: function fn(val, pattern) {
	            var m = pattern.match(new RegExp('^/(.*?)/([gimy]*)$'));return !val || new RegExp(m[1], m[2]).test(val);
	        } });
	
	    function Pristine(form, config, live) {
	
	        var self = this;
	
	        init(form, config, live);
	
	        function init(form, config, live) {
	
	            form.setAttribute("novalidate", "true");
	
	            self.form = form;
	            self.config = mergeConfig(config || {}, defaultConfig);
	            self.live = !(live === false);
	            self.fields = Array.from(form.querySelectorAll(SELECTOR)).map(function (input) {
	
	                var fns = [];
	                var params = {};
	                var messages = {};
	
	                [].forEach.call(input.attributes, function (attr) {
	                    if (/^data-pristine-/.test(attr.name)) {
	                        var name = attr.name.substr(14);
	                        if (name.endsWith('-message')) {
	                            messages[name.slice(0, name.length - 8)] = attr.value;
	                            return;
	                        }
	                        if (name === 'type') name = attr.value;
	                        _addValidatorToField(fns, params, name, attr.value);
	                    } else if (~ALLOWED_ATTRIBUTES.indexOf(attr.name)) {
	                        _addValidatorToField(fns, params, attr.name, attr.value);
	                    } else if (attr.name === 'type') {
	                        _addValidatorToField(fns, params, attr.value);
	                    }
	                });
	
	                fns.sort(function (a, b) {
	                    return b.priority - a.priority;
	                });
	
	                self.live && input.addEventListener(!~['radio', 'checkbox'].indexOf(input.getAttribute('type')) ? 'input' : 'change', function (e) {
	                    self.validate(e.target);
	                }.bind(self));
	
	                return input.pristine = { input: input, validators: fns, params: params, messages: messages, self: self };
	            }.bind(self));
	        }
	
	        function _addValidatorToField(fns, params, name, value) {
	            var validator = validators[name];
	            if (validator) {
	                fns.push(validator);
	                if (value) {
	                    var valueParams = value.split(',');
	                    valueParams.unshift(null); // placeholder for input's value
	                    params[name] = valueParams;
	                }
	            }
	        }
	
	        /***
	         * Checks whether the form/input elements are valid
	         * @param input => input element(s) or a jquery selector, null for full form validation
	         * @param silent => do not show error messages, just return true/false
	         * @returns {boolean} return true when valid false otherwise
	         */
	        self.validate = function (input, silent) {
	            silent = input && silent === true || input === true;
	            var fields = self.fields;
	            if (input !== true && input !== false) {
	                if (input instanceof HTMLElement) {
	                    fields = [input.pristine];
	                } else if (input instanceof NodeList || input instanceof (window.$ || Array) || input instanceof Array) {
	                    fields = Array.from(input).map(function (el) {
	                        return el.pristine;
	                    });
	                }
	            }
	
	            var valid = true;
	
	            for (var i = 0; fields[i]; i++) {
	                var field = fields[i];
	                if (_validateField(field)) {
	                    !silent && _showSuccess(field);
	                } else {
	                    valid = false;
	                    !silent && _showError(field);
	                }
	            }
	            return valid;
	        };
	
	        /***
	         * Get errors of a specific field or the whole form
	         * @param input
	         * @returns {Array|*}
	         */
	        self.getErrors = function (input) {
	            if (!input) {
	                var erroneousFields = [];
	                for (var i = 0; i < self.fields.length; i++) {
	                    var field = self.fields[i];
	                    if (field.errors.length) {
	                        erroneousFields.push({ input: field.input, errors: field.errors });
	                    }
	                }
	                return erroneousFields;
	            }
	            if (input.tagName && input.tagName.toLowerCase() === "select") {
	                return input.pristine.errors;
	            }
	            return input.length ? input[0].pristine.errors : input.pristine.errors;
	        };
	
	        /***
	         * Validates a single field, all validator functions are called and error messages are generated
	         * when a validator fails
	         * @param field
	         * @returns {boolean}
	         * @private
	         */
	        function _validateField(field) {
	            var errors = [];
	            var valid = true;
	            for (var i = 0; field.validators[i]; i++) {
	                var validator = field.validators[i];
	                var params = field.params[validator.name] ? field.params[validator.name] : [];
	                params[0] = field.input.value;
	                if (!validator.fn.apply(field.input, params)) {
	                    valid = false;
	
	                    if (isFunction(validator.msg)) {
	                        errors.push(validator.msg(field.input.value, params));
	                    } else {
	                        var error = field.messages[validator.name] || validator.msg;
	                        errors.push(tmpl.apply(error, params));
	                    }
	
	                    if (validator.halt === true) {
	                        break;
	                    }
	                }
	            }
	            field.errors = errors;
	            return valid;
	        }
	
	        /***
	         *
	         * @param elem => The dom element where the validator is applied to
	         * @param fn => validator function
	         * @param msg => message to show when validation fails. Supports templating. ${0} for the input's value, ${1} and
	         * so on are for the attribute values
	         * @param priority => priority of the validator function, higher valued function gets called first.
	         * @param halt => whether validation should stop for this field after current validation function
	         */
	        self.addValidator = function (elem, fn, msg, priority, halt) {
	            if (elem instanceof HTMLElement) {
	                elem.pristine.validators.push({ fn: fn, msg: msg, priority: priority, halt: halt });
	                elem.pristine.validators.sort(function (a, b) {
	                    return b.priority - a.priority;
	                });
	            } else {
	                console.warn("The parameter elem must be a dom element");
	            }
	        };
	
	        /***
	         * An utility function that returns a 2-element array, first one is the element where error/success class is
	         * applied. 2nd one is the element where error message is displayed. 2nd element is created if doesn't exist and cached.
	         * @param field
	         * @returns {*}
	         * @private
	         */
	        function _getErrorElements(field) {
	            if (field.errorElements) {
	                return field.errorElements;
	            }
	            var errorClassElement = findAncestor(field.input, self.config.classTo);
	            var errorTextParent = null,
	                errorTextElement = null;
	            if (self.config.classTo === self.config.errorTextParent) {
	                errorTextParent = errorClassElement;
	            } else {
	                errorTextParent = errorClassElement.querySelector('.' + self.config.errorTextParent);
	            }
	            if (errorTextParent) {
	                errorTextElement = errorTextParent.querySelector('.' + PRISTINE_ERROR);
	                if (!errorTextElement) {
	                    errorTextElement = document.createElement(self.config.errorTextTag);
	                    errorTextElement.className = PRISTINE_ERROR + ' ' + self.config.errorTextClass;
	                    errorTextParent.appendChild(errorTextElement);
	                    errorTextElement.pristineDisplay = errorTextElement.style.display;
	                }
	            }
	            return field.errorElements = [errorClassElement, errorTextElement];
	        }
	
	        function _showError(field) {
	            var errorElements = _getErrorElements(field);
	            var errorClassElement = errorElements[0],
	                errorTextElement = errorElements[1];
	
	            if (errorClassElement) {
	                errorClassElement.classList.remove(self.config.successClass);
	                errorClassElement.classList.add(self.config.errorClass);
	            }
	            if (errorTextElement) {
	                errorTextElement.innerHTML = field.errors.join('<br/>');
	                errorTextElement.style.display = errorTextElement.pristineDisplay || '';
	            }
	        }
	
	        /***
	         * Adds error to a specific field
	         * @param input
	         * @param error
	         */
	        self.addError = function (input, error) {
	            input = input.length ? input[0] : input;
	            input.pristine.errors.push(error);
	            _showError(input.pristine);
	        };
	
	        function _removeError(field) {
	            var errorElements = _getErrorElements(field);
	            var errorClassElement = errorElements[0],
	                errorTextElement = errorElements[1];
	            if (errorClassElement) {
	                // IE > 9 doesn't support multiple class removal
	                errorClassElement.classList.remove(self.config.errorClass);
	                errorClassElement.classList.remove(self.config.successClass);
	            }
	            if (errorTextElement) {
	                errorTextElement.innerHTML = '';
	                errorTextElement.style.display = 'none';
	            }
	            return errorElements;
	        }
	
	        function _showSuccess(field) {
	            var errorClassElement = _removeError(field)[0];
	            errorClassElement && errorClassElement.classList.add(self.config.successClass);
	        }
	
	        /***
	         * Resets the errors
	         */
	        self.reset = function () {
	            for (var i = 0; self.fields[i]; i++) {
	                self.fields[i].errorElements = null;
	            }
	            Array.from(self.form.querySelectorAll('.' + PRISTINE_ERROR)).map(function (elem) {
	                elem.parentNode.removeChild(elem);
	            });
	            Array.from(self.form.querySelectorAll('.' + self.config.classTo)).map(function (elem) {
	                elem.classList.remove(self.config.successClass);
	                elem.classList.remove(self.config.errorClass);
	            });
	        };
	
	        /***
	         * Resets the errors and deletes all pristine fields
	         */
	        self.destroy = function () {
	            self.reset();
	            self.fields.forEach(function (field) {
	                delete field.input.pristine;
	            });
	            self.fields = [];
	        };
	
	        self.setGlobalConfig = function (config) {
	            defaultConfig = config;
	        };
	
	        return self;
	    }
	
	    /***
	     *
	     * @param name => Name of the global validator
	     * @param fn => validator function
	     * @param msg => message to show when validation fails. Supports templating. ${0} for the input's value, ${1} and
	     * so on are for the attribute values
	     * @param priority => priority of the validator function, higher valued function gets called first.
	     * @param halt => whether validation should stop for this field after current validation function
	     */
	    Pristine.addValidator = function (name, fn, msg, priority, halt) {
	        _(name, { fn: fn, msg: msg, priority: priority, halt: halt });
	    };
	
	    return Pristine;
	
	})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = recaptchaDirective;
	
	var _request = __webpack_require__(27);
	
	var _data = __webpack_require__(12);
	
	/**
	 * @module directives/form/recaptcha
	 */
	
	/**
	 * Enhances forms with Google reCAPTCHA functionality. Requires use of the reCAPTCHA Craft plugin.
	 */
	function recaptchaDirective() {
	  var recaptchaPath = 'https://www.google.com/recaptcha/api.js',
	      forms = document.querySelectorAll('form[data-sw-recaptcha]');
	  if (forms.length > 0) {
	    (0, _request.dependency)(recaptchaPath, function () {
	      if (!window.grecaptcha) return false;
	      forms.forEach(function (form) {
	        var recaptcha = form.querySelector('.g-recaptcha');
	        var callbackName = form.getAttribute('data-sw-recaptcha');
	        window[callbackName] = function (event) {
	          var validator = (0, _data.getData)(form, 'validator');
	          var preSubmit = window.hsFormWillSubmit ? window.hsFormWillSubmit : function () {};
	          if (validator) {
	            validator.runSubmission(event, preSubmit);
	          } else {
	            preSubmit();form.submit();
	          }
	          recaptcha.disabled = false;
	          recaptcha.removeAttribute('disabled');
	        };
	      });
	      return true;
	    });
	  }
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dependency = dependency;
	/**
	 * Module for loading JS dependencies.
	 * @module  utils/request
	 */
	
	/**
	 * Loads an external Javascript file and executes it.
	 * @param {String} url - URL to a JS resource.
	 * @param {Function} [check=true] - An optional function that should return true/false (strict) for checking if the loaded JS file has executed correctly.
	 * @param {Number} [timeout=10000] - The fail timeout.
	 * @return {Promise} 
	 */
	var loadedDependencies = null;
	function dependency(url) {
	  var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_) {
	    return true;
	  };
	  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	
	  // Lock off any existing dependencies so we don't load them twice
	  if (!loadedDependencies) {
	    loadedDependencies = {};
	    document.querySelectorAll('script[src]').forEach(function (script) {
	      loadedDependencies[script.getAttribute('src')] = true;
	    });
	  }
	
	  // Return load promise
	  return new Promise(function (resolve, reject) {
	    var startTime = Date.now();
	    var poll = function poll(_) {
	      if (check() === true) resolve();else if (Date.now() - startTime > timeout) reject();else setTimeout(poll, 50);
	    };
	    if (!loadedDependencies[url]) {
	      loadedDependencies[url] = true;
	      var script = document.createElement('script');
	      script.src = url;
	      script.async = true;
	      script.onload = poll;
	      document.head.appendChild(script);
	    } else {
	      poll();
	    }
	  });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightboxDirective;
	
	var _request = __webpack_require__(27);
	
	var _parse = __webpack_require__(8);
	
	var _drawing = __webpack_require__(10);
	
	var _data = __webpack_require__(12);
	
	/**
	 * @module directives/media/lightbox
	 */
	
	/**
	 * The CDN directory of the PhotoSwipe library.
	 * @see http://photoswipe.com
	 * @type {String}
	 */
	var photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';
	
	/**
	 * The reusable template for PhotoSwipe.
	 * @see http://photoswipe.com/documentation/getting-started.html
	 */
	var template = '<div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">\n  <div class="pswp__bg"></div>\n    <div class="pswp__scroll-wrap">\n      <div class="pswp__container">\n        <div class="pswp__item lightbox_item"></div>\n        <div class="pswp__item lightbox_item"></div>\n        <div class="pswp__item lightbox_item"></div>\n      </div>\n      <div class="pswp__ui pswp__ui--hidden">\n        <div class="pswp__top-bar">\n            <div class="pswp__counter"></div>\n            <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n            <button class="pswp__button pswp__button--share" title="Share"></button>\n            <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n            <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n            <div class="pswp__preloader">\n                <div class="pswp__preloader__icn">\n                  <div class="pswp__preloader__cut">\n                    <div class="pswp__preloader__donut"></div>\n                  </div>\n                </div>\n            </div>\n        </div>\n        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n          <div class="pswp__share-tooltip"></div>\n        </div>\n        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n        <div class="pswp__caption">\n          <div class="pswp__caption__center"></div>\n        </div>\n      </div>\n  </div>\n</div>';
	
	/** flags */
	var initialised = false;
	var pswpElement = null;
	
	/**
	 * Initializes a PhotoSwipe gallery.
	 * @see http://idangero.us/swiper
	 */
	function lightboxDirective() {
	
	  var lightboxes = document.querySelectorAll('[data-sw-lightbox]');
	  if (lightboxes.length > 0) {
	    if (!initialised) {
	      initialised = true;
	
	      // Add style elements to head
	      document.head.appendChild((0, _drawing.newElement)('link', {
	        type: 'text/css',
	        rel: 'stylesheet',
	        href: photoswipeDir + 'photoswipe.min.css'
	      }));
	      document.head.appendChild((0, _drawing.newElement)('link', {
	        type: 'text/css',
	        rel: 'stylesheet',
	        href: photoswipeDir + 'default-skin/default-skin.min.css'
	      }));
	
	      // Add template to body and get container
	      document.body.appendChild((0, _drawing.newElement)('div', {}, template));
	      pswpElement = document.getElementById('lightbox');
	    }
	
	    // Load library and setup
	    (0, _request.dependency)(photoswipeDir + 'photoswipe.min.js');
	    (0, _request.dependency)(photoswipeDir + 'photoswipe-ui-default.min.js', function (_) {
	      return window.PhotoSwipe !== null && window.PhotoSwipeUI_Default !== null;
	    }).then(function (_) {
	
	      var groups = {};
	      lightboxes.forEach(function (element) {
	        var data = element.getAttribute('data-sw-lightbox'),
	            settings = (0, _parse.directiveSettings)(data, {
	          group: null,
	          thumbnailUrl: '',
	          html: '',
	          url: '',
	          width: 1280,
	          height: 720,
	          title: null
	        }, 'url');
	
	        settings.group = settings.group || (0, _data.uniqueId)();
	
	        if (!(settings.group in groups)) {
	          groups[settings.group] = {
	            elements: [],
	            items: []
	          };
	        }
	
	        var group = groups[settings.group],
	            item = {
	          msrc: settings.thumbnailUrl,
	          w: settings.width | 0,
	          h: settings.height | 0,
	          title: settings.title
	        };
	
	        if (settings.html) item.html = settings.html;else item.src = settings.url;
	
	        group.elements.push(element);
	        group.items.push(item);
	
	        element.addEventListener('click', function (event) {
	          event.preventDefault();
	
	          var options = {
	            history: false,
	            index: group.elements.indexOf(element),
	            getThumbBoundsFn: function getThumbBoundsFn(index) {
	              var currentElement = group.elements[index],
	                  thumb = currentElement.matches('[data-sw-lightbox-thumb]') ? currentElement : currentElement.querySelector('[data-sw-lightbox-thumb]');
	
	              if (!currentElement) return null;
	
	              var width = thumb.offsetHeight,
	                  height = thumb.offsetHeight;
	
	              // If the thumbnail has been letterboxed, this will get the correct width
	              var trueWidth = Math.min(width, height / settings.height * settings.width);
	              return {
	                x: thumb.offsetLeft + (width - trueWidth) / 2,
	                y: thumb.offsetTop,
	                w: trueWidth
	              };
	            }
	          };
	
	          var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
	          gallery.init();
	        });
	      });
	    });
	  }
	}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = playOnHoverDirective;
	/**
	 * @module directives/media/play-on-hover
	 */
	
	/**
	 * Play video on hover.
	 */
	function playOnHoverDirective() {
	  document.querySelectorAll('[data-sw-play-on-hover]').forEach(function (element) {
	    element.addEventListener('mouseenter', function (_) {
	      element.querySelectorAll('video').forEach(function (video) {
	        if (!video.ended || video.loop) video.play();
	      });
	    });
	    element.addEventListener('mouseleave', function (_) {
	      element.querySelectorAll('video').forEach(function (video) {
	        video.pause();
	      });
	    });
	  });
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapDirective;
	
	var _request = __webpack_require__(27);
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	/**
	 * @module directives/media/map
	 */
	
	/**
	 * Initializes a Google Map.
	 */
	function mapDirective() {
	  var apiUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places';
	
	  document.querySelectorAll('[data-sw-map]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-map'),
	        settings = (0, _parse.directiveSettings)(data, {
	      apiKey: null,
	      lat: 0,
	      lng: 0,
	      zoom: 0,
	      control: false,
	      marker: true,
	      markerColor: false,
	      link: null,
	      style: []
	    });
	
	    if (settings.apiKey) {
	      (0, _request.dependency)(apiUrl + ('&key=' + settings.apiKey), function (_) {
	        return window.google && google.maps;
	      }).then(function () {
	        var point = new google.maps.LatLng(settings.lat, settings.lng),
	            map = new google.maps.Map(element, {
	          center: point,
	          zoom: settings.zoom,
	          mapTypeId: google.maps.MapTypeId.ROADMAP,
	          scrollwheel: false,
	          streetViewControl: false,
	          draggable: settings.control,
	          panControl: false,
	          overviewMapControl: false,
	          zoomControl: settings.control,
	          mapTypeControl: false,
	          disableDefaultUI: true,
	          disableDoubleClickZoom: true,
	          styles: settings.style
	        });
	
	        var offset = 0;
	        if (settings.marker) {
	          var icon = settings.markerColor ? {
	            path: 'M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76c-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z',
	            anchor: new google.maps.Point(10, 20),
	            scale: 4,
	            fillColor: settings.markerColor,
	            fillOpacity: 1,
	            strokeWeight: 0
	          } : null;
	
	          var marker = new google.maps.Marker({ map: map, icon: icon, position: point });
	          if (settings.link) marker.addListener('click', function (_) {
	            return window.open(settings.link, '_blank');
	          });
	        }
	
	        function recenterMap() {
	          map.setCenter(point);
	          map.panBy(0, offset);
	        }
	        recenterMap();
	
	        (0, _window.onResize)(recenterMap);
	        window.addEventListener('load', (0, _window.frame)(recenterMap));
	      });
	    }
	  });
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fadeDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	/**
	 * @module directives/scroll/fade
	 */
	
	/**
	 * Fades an element out or in, the closer or farther it moves to or from the top of the window.
	 * Start fade-out once an element reaches 25% of the window height: <div data-sw-fade="0.25"></div>
	 * Start fade-out at 75% of the window height, and finish at 25%, based on the top position of the element:
	 * <div data-sw-fade='{ scroll: 0.5, position: 'top', offset: 0.25 }'></div>
	 */
	function fadeDirective() {
	  document.querySelectorAll('[data-sw-fade]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-fade'),
	        settings = (0, _parse.directiveSettings)(data, {
	      scroll: 0.25,
	      position: 'middle',
	      offset: 0
	    }, 'scroll');
	
	    (0, _window.onScroll)(function (_) {
	      var scrollTop = (0, _window.getScrollTop)(),
	          elementOffset = element.offsetTop - window.innerHeight * settings.offset,
	          elementHeight = element.clientHeight;
	
	      var elementPosition = void 0;
	      switch (settings.position) {
	        case 'top':
	          elementPosition = 0;break;
	        case 'bottom':
	          elementPosition = elementHeight;break;
	        default:
	          elementPosition = elementHeight / 2;break;
	      }
	      var contentPos = elementOffset + elementPosition - scrollTop,
	          fadeHeight = window.innerHeight * settings.scroll;
	
	      var opacity = contentPos / fadeHeight;
	      if (opacity < 0) opacity = 0;else if (opacity > 1) opacity = 1;
	      if (parseFloat(element.style.opacity) !== opacity) {
	        element.style.opacity = opacity;
	      }
	    });
	  });
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lazyLoadDirective;
	
	var _data = __webpack_require__(12);
	
	var _drawing = __webpack_require__(10);
	
	var _blazy = __webpack_require__(33);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @module directives/scroll/lazy-load
	 */
	
	/**
	 * Lazily loads images, backgrounds, videos and iframes.
	 * @see http://dinbror.dk/blog/blazy/
	 * @param {HTMLElement} [context=document.body] - Optional DOM context.
	 */
	function lazyLoadDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var container = 'window';
	  if (context !== document.body) {
	
	    // Blazy needs a string selector, so if we aren't in body context build it off the element, or put one on
	    container = context.tagName.toLowerCase();
	    if (context.getAttribute('id')) {
	      container += '#' + context.getAttribute('id');
	    } else {
	      var id = 'data-blazy-' + (0, _data.uniqueId)();
	      context.setAttribute(id, "true");
	      container += '[' + id + ']';
	    }
	  }
	
	  // Create the blazy, revalidate on load
	  var blazy = new _blazy2.default({
	    container: container,
	    selector: '[data-sw-lazy-load]',
	    src: 'data-sw-lazy-load',
	    successClass: 'is-ready',
	    errorClass: 'is-broken'
	  });
	
	  window.addEventListener('load', blazy.revalidate);
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = 'src', _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.containerClass = scope.options.container;
	        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _supportClosest = Element.prototype.closest;
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(scope);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements && elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {            
	            var util = scope._util;
	            if (scope.options.container) {
	                each(scope.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele, options) {
	        var rect = ele.getBoundingClientRect();
	
	        if(options.container && _supportClosest){
	            // Is element inside a container?
	            var elementContainer = ele.closest(options.containerClass);
	            if(elementContainer){
	                var containerRect = elementContainer.getBoundingClientRect();
	                // Is container in view?
	                if(inView(containerRect, _viewport)){
	                    var top = containerRect.top - options.offset;
	                    var right = containerRect.right + options.offset;
	                    var bottom = containerRect.bottom + options.offset;
	                    var left = containerRect.left - options.offset;
	                    var containerRectWithOffset = {
	                        top: top > _viewport.top ? top : _viewport.top,
	                        right: right < _viewport.right ? right : _viewport.right,
	                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
	                        left: left > _viewport.left ? left : _viewport.left
	                    };
	                    // Is element in view of container?
	                    return inView(rect, containerRectWithOffset);
	                } else {
	                    return false;
	                }
	            }
	        }      
	        return inView(rect, _viewport);
	    }
	
	    function inView(rect, viewport){
	        // Intersection
	        return rect.right >= viewport.left &&
	               rect.bottom >= viewport.top && 
	               rect.left <= viewport.right && 
	               rect.top <= viewport.bottom;
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var srcset = getAttr(ele, options.srcset);
	                var isImage = equal(ele, 'img');
	                var parent = ele.parentNode;
	                var isPicture = parent && equal(parent, 'picture');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            if(!isPicture) {
	                                handleSources(ele, src, srcset);
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    
	                    // Picture element
	                    if (isPicture) {
	                        img = ele; // Image tag inside picture element wont get preloaded
	                        each(parent.getElementsByTagName('source'), function(source) {
	                            handleSource(source, _attrSrcset, options.srcset);
	                        });
	                    }
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    handleSources(img, src, srcset); // Preload
	
	                } else { // An item with src like iframe, unity games, simpel video etc
	                    ele.src = src;
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        removeAttr(ele, options.src);
	        removeAttr(ele, options.srcset);
	        each(options.breakpoints, function(object) {
	            removeAttr(ele, object.src);
	        });
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = getAttr(ele, dataAttr);
	        if (dataSrc) {
	            setAttr(ele, attr, dataSrc);
	            removeAttr(ele, dataAttr);
	        }
	    }
	
	    function handleSources(ele, src, srcset){
	        if(srcset) {
	            setAttr(ele, _attrSrcset, srcset); //srcset
	        }
	        ele.src = src; //src 
	    }
	
	    function setAttr(ele, attr, value){
	        ele.setAttribute(attr, value);
	    }
	
	    function getAttr(ele, attr) {
	        return ele.getAttribute(attr);
	    }
	
	    function removeAttr(ele, attr){
	        ele.removeAttribute(attr); 
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parallaxDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	var _drawing = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @module directives/scroll/parallax
	 */
	
	/**
	 * Adds parallax to an element.
	 * Parallax with 75% speed: <div data-sw-parallax="0.75"></div>
	 * Parallax for background images: <div data-sw-parallax="{ scale: true }"></div>
	 */
	function parallaxDirective() {
	  [].concat(_toConsumableArray(document.querySelectorAll('[data-sw-parallax]'))).forEach(function (element) {
	    var data = element.getAttribute('data-sw-parallax'),
	        settings = (0, _parse.directiveSettings)(data, {
	      speed: 0.5,
	      align: 0.5,
	      target: false,
	      scale: false,
	      axis: 'y'
	    }, 'speed'),
	        target = settings.target && !settings.scale ? document.getElementById(settings.target) : null;
	
	    var height = void 0,
	        offsetTop = void 0,
	        transform = void 0;
	    var scroll = function scroll(_) {
	      var scrollTop = (0, _window.getScrollTop)(),
	          targetHeight = target ? target.clientHeight : window.innerHeight,
	          scaleOffset = (targetHeight - height) * settings.align,
	          translate = (scrollTop - offsetTop + scaleOffset) * (settings.speed - 1);
	
	      if (settings.axis === 'y') {
	        element.style.transform = 'translate3d(0, ' + -translate + 'px, 0) ' + transform;
	      } else {
	        element.style.transform = 'translate3d(' + -translate + 'px, ' + -translate + 'px, 0) ' + transform;
	      }
	    },
	        setup = function setup(_) {
	      element.style.transform = '';
	      element.style.transformOrigin = 'top center';
	      element.offsetWidth; // accesss for reflow
	      height = element.offsetHeight;
	      offsetTop = element.offsetTop;
	      if (settings.scale) {
	        var viewHeight = Math.min(window.innerHeight, offsetTop + height),
	            newHeight = viewHeight - (viewHeight - height) * settings.speed;
	        transform = 'scale(' + newHeight / height + ')';
	      } else {
	        transform = '';
	      }
	      scroll();
	    };
	
	    (0, _window.onResize)(setup);
	    (0, _window.onScroll)(scroll);
	
	    window.addEventListener('load', function () {
	      return (0, _drawing.frame)(setup);
	    });
	  });
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = revealDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	var _drawing = __webpack_require__(10);
	
	var _inspection = __webpack_require__(36);
	
	/**
	 * @module directives/scroll/reveal
	 */
	
	/**
	 * Reveals elements on scroll.
	 */
	function revealDirective() {
	  var revealers = document.querySelectorAll('[data-sw-reveal]');
	
	  // only setup if not a touchscreen
	  if (!(0, _inspection.isTouch)()) {
	
	    // reveal check
	    var checkForReveal = function checkForReveal(element) {
	      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var top = (0, _window.getScrollTop)(),
	          scrolled = top + window.innerHeight > element.offsetTop;
	      if (scrolled && !element.classList.contains('is-revealed')) {
	        element.classList.add('is-revealed');
	      } else if (reset && !scrolled && element.classList.contains('is-revealed')) {
	        element.classList.remove('is-revealed');
	      }
	    };
	
	    // hook up all scroll reveal elements
	    revealers.forEach(function (element) {
	      var data = element.getAttribute('data-sw-reveal'),
	          settings = (0, _parse.directiveSettings)(data, {
	        force: false,
	        reset: true
	      }, 'force');
	
	      if (!settings.force) element.style.transition = 'none';
	
	      checkForReveal(element, settings.reset);
	
	      if (!settings.force) (0, _drawing.frame)(function (_) {
	        element.style.transition = '';
	      });
	      (0, _window.onScroll)(function (_) {
	        return checkForReveal(element, settings.reset);
	      });
	    });
	  } else {
	
	    // on touchscreens just reveal everything
	    revealers.forEach(function (element) {
	      element.style.transition = 'none';
	      element.classList.add('is-revealed');
	    });
	  }
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	exports.isSafari = isSafari;
	/**
	 * Browser inspection helpers.
	 * @module utils/inepction
	 */
	
	/**
	 * Crude check to see if the device is a touch screen.
	 * @see http://stackoverflow.com/a/4819886/556609
	 * @returns {Boolean}
	 */
	function isTouch() {
	  return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 * @param {Number} [version=null] - Optionally check a specific version (11, 10, or 9)
	 * @returns {Boolean}
	 */
	function isIE() {
	  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  var ua = navigator.userAgent;
	  var is11 = /rv:11\.0/i.test(ua);
	  var is10 = /MSIE 10/i.test(ua);
	  var is9 = /MSIE 9/i.test(ua);
	
	  switch (version) {
	    case 11:
	      return is11;
	    case 10:
	      return is10;
	    case 9:
	      return is9;
	  }
	
	  return is11 && is10 && is9;
	}
	
	/**
	 * Crude check to see if the browser is Safari.
	 * @returns {Boolean}
	 */
	function isSafari() {
	  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	  );
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stickyDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	var _drawing = __webpack_require__(10);
	
	/**
	 * @module directives/scroll/sticky
	 */
	
	/**
	 * Sticks an element top the top of the screen.
	 */
	function stickyDirective() {
	
	  // Add sticky behaviour
	  document.querySelectorAll('[data-sw-sticky]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-sticky'),
	        settings = (0, _parse.directiveSettings)(data, {
	      name: '',
	      offset: 0
	    }, 'name');
	
	    // Find or create/insert filler elememt
	    var fixed = false,
	        filler = settings.name ? document.querySelector('[data-sw-sticky-filler=\'' + settings.name + '\']') : null;
	    if (!filler) {
	      filler = document.createElement("div");
	      filler.setAttribute("data-sw-sticky-filler", settings.name);
	      filler.style.display = 'none';
	      element.parentElement.insertBefore(filler, element);
	    }
	
	    // Sticky functions
	    var fillerSize = function fillerSize(_) {
	      filler.style.height = element.offsetHeight + 'px';
	    };
	
	    var stickyScroll = function stickyScroll(_) {
	      var scrollTop = (0, _window.getScrollTop)();
	      if (fixed) {
	        var fillerTop = filler.offsetTop + settings.offset;
	        if (scrollTop <= fillerTop) {
	          fixed = false;
	          fixSticky(false);
	        }
	      } else {
	        var stickyTop = filler.offsetTop + settings.offset;
	        if (scrollTop > stickyTop) {
	          fixed = true;
	          fixSticky(true);
	        }
	      }
	    };
	
	    var fixSticky = function fixSticky(fix) {
	      if (fix) {
	        filler.style.display = '';
	        element.classList.add('is-stuck');
	        element.classList.remove('is-unstuck');
	      } else {
	        filler.style.display = 'none';
	        element.classList.remove('is-stuck');
	        element.classList.add('is-unstuck');
	      }
	    };
	
	    // Init/events
	    window.addEventListener('load', function () {
	      (0, _drawing.frame)(fillerSize);
	      (0, _drawing.frame)(stickyScroll);
	      (0, _window.onResize)(function (_) {
	        fillerSize();
	        stickyScroll();
	      });
	      (0, _window.onScroll)(stickyScroll);
	      (0, _drawing.frame)(function (_) {
	        return fixSticky(fixed);
	      });
	    });
	  });
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inspectScrollDirective;
	
	var _parse = __webpack_require__(8);
	
	var _window = __webpack_require__(9);
	
	/**
	 * @module directives/inspect/inspect-scroll
	 */
	
	/**
	 * Toggles a class on an element on scroll.
	 */
	function inspectScrollDirective() {
	
	  // for each scroll inspector toggle hidden class on scoll
	  document.querySelectorAll('[data-sw-inspect-scroll]').forEach(function (element) {
	    var data = element.getAttribute('data-sw-inspect-scroll'),
	        settings = (0, _parse.directiveSettings)(data, {
	      target: null,
	      class: 'is-scrollable',
	      inverted: false
	    }, 'target'),
	        target = document.getElementById(settings.target) || element;
	
	    if (target) {
	      var scroll = function scroll(_) {
	        var scrolling = target.scrollWidth - target.clientWidth > 0 || target.scrollHeigth - target.clientHeight > 0;
	        element.classList.toggle(settings.class, settings.inverted ? !scrolling : scrolling);
	      };
	      (0, _window.onScroll)(scroll);
	      scroll();
	    }
	  });
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = modalSection;
	
	var _data = __webpack_require__(12);
	
	/**
	 * Modal controls.
	 */
	function modalSection() {
		var html = document.getElementsByTagName('html')[0],
		    modal = document.getElementById('modal'),
		    iframe = modal.querySelector('iframe'),
		    toggler = (0, _data.getData)(document.getElementById('modal'), 'toggler');
	
		if (toggler) {
	
			iframe.addEventListener('load', function () {
				try {
					var href = $iframe[0].contentWindow.location.href;
					toggler.toggle(href !== 'about:blank');
				} catch (e) {
					toggler.close();
				}
			});
	
			modal.addEventListener('click', function (event) {
				if (event.target === modal) toggler.close();
			});
	
			toggler.on('toggle', function (_) {
				html.classList[toggler.isOpen ? 'add' : 'remove']('is-modal-open');
			});
		}
	}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = headerSection;
	
	var _window = __webpack_require__(9);
	
	var _drawing = __webpack_require__(10);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Header controls.
	 */
	function headerSection() {
	  var _this = this;
	
	  // Menu breakpoint
	  var isMobileView = function isMobileView() {
	    return (0, _window.getWidth)() < 960;
	  };
	
	  // scroll changes
	  var header = document.getElementById('header');
	  var lastSt = 0;
	  var gateHeight = 100;
	  (0, _window.onScroll)(function (e) {
	    var st = (0, _window.getScrollTop)();
	    if (st > lastSt) {
	      // downscroll code
	      if (st > gateHeight) {
	        header.classList.add('is-scrolled');
	      }
	    } else {
	      // upscroll code
	      if (st <= gateHeight) {
	        header.classList.remove('is-scrolled');
	      }
	    }
	    lastSt = st;
	  });
	
	  // ------------------------------------------------------------------
	  // All menus
	  var menuParents = document.querySelectorAll('nav.header_menu li.parent > a');
	  var superMenus = document.querySelectorAll('nav.header_menu div.header_new-super-menu');
	  var mobileMenu = document.querySelector('nav.header_new-mobile-menu');
	  var mobileMenuButton = document.getElementById('mobile-menu-button');
	
	  var menuReset = function menuReset() {
	    var all = document.querySelectorAll("nav.header_menu *");
	    all.forEach(function (el) {
	      el.classList.remove('-is-open');
	      el.classList.remove('-is-expanded');
	      el.classList.remove('-is-clicked');
	    });
	  };
	
	  // ------------------------------------------------------------------
	  // Header menus
	  if (menuParents) {
	
	    var setupMenu = function setupMenu(resize) {
	
	      menuReset();
	
	      // Top level items (all events)
	      menuParents.forEach(function (parent) {
	
	        if (!parent.parentNode) return;
	
	        // Click menu parent
	        var clickParent = function clickParent(event) {
	
	          event.preventDefault();
	
	          // find super with this ID
	          if (superMenus) superMenus.forEach(function (spm) {
	            if (spm.dataset.superMenuId !== parent.parentNode.dataset.menuId) {
	
	              if (spm.classList.contains('-is-open')) {
	
	                spm.classList.add('-is-closing');
	
	                setTimeout(function () {
	                  spm.classList.remove('-is-closing');
	                }, 500);
	              }
	
	              spm.classList.remove('-is-open');
	              spm.classList.remove('-is-expanded');
	            }
	          });
	          var spm = document.querySelector('[data-super-menu-id="' + parent.parentNode.dataset.menuId + '"]');
	          if (spm) {
	            spm.classList.toggle('-is-open');
	
	            if (spm.classList.contains('-is-open')) {
	              document.querySelector("html").classList.add('is-header-open');
	            } else {
	              document.querySelector("html").classList.remove('is-header-open');
	            }
	          }
	        };
	
	        // parent.removeEventListener('click', clickParent);
	        parent.addEventListener('click', clickParent);
	
	        // Super menu parents (open the supermenu sub menu)
	        var superMenuParents = parent.parentNode.querySelectorAll('.header_new-super-menu--parent li.item');
	        superMenuParents.forEach(function (superParent) {
	
	          var eventType = isMobileView() ? 'click' : 'mouseenter';
	
	          var clickSuperParent = function clickSuperParent(event) {
	
	            if (!superParent.classList.contains('-has-subs') || isMobileView()) return; // No sub items, so just click as normal
	
	            event.preventDefault();
	
	            superMenus.forEach(function (s) {
	              return s.classList.add('-is-expanded');
	            });
	            superMenuParents.forEach(function (smp) {
	              return smp.classList.remove('-is-clicked');
	            });
	            superParent.classList.add('-is-clicked');
	
	            var superId = superParent.dataset.superId;
	            var subMenus = document.querySelectorAll('.header_new-super-menu--subs ul[data-super-id="' + superId + '"]');
	
	            // hide all subs
	            document.querySelectorAll('.header_new-super-menu--subs ul').forEach(function (sub) {
	              sub.classList.remove('-is-open');
	            });
	
	            if (subMenus) subMenus.forEach(function (sub) {
	              sub.classList.add('-is-open');
	            });
	          };
	          superParent.removeEventListener(eventType, clickSuperParent);
	          superParent.addEventListener(eventType, clickSuperParent);
	        });
	
	        // Exit button
	        var superMenuExitButton = parent.parentNode.querySelectorAll('.header_new-super-menu--parent button.super-menu-exit-button');
	        superMenuExitButton.forEach(function (spmeb) {
	          spmeb.addEventListener('click', function (event) {
	            mobileMenu.classList.remove('-is-offscreen');
	            superMenus.forEach(function (s) {
	              return s.classList.remove('-is-open');
	            });
	          });
	        });
	
	        // Back button
	        var superMenuBackButton = parent.parentNode.querySelectorAll('.header_new-super-menu--subs button.super-menu-back-button');
	        superMenuBackButton.forEach(function (spmbb) {
	          spmbb.addEventListener('click', function (event) {
	            superMenus.forEach(function (s) {
	              return s.classList.remove('-is-expanded');
	            });
	          });
	        });
	      });
	    };
	
	    // Reset for resize
	    // onResize(() => setupMenu(true));
	    setupMenu();
	
	    // ------------------------------------------------------------------
	    // Mobile menu
	    if (mobileMenuButton && mobileMenu) {
	      mobileMenuButton.addEventListener('click', function (event) {
	
	        if (mobileMenu.classList.contains('-is-open')) {
	          mobileMenu.classList.remove('-is-open');
	          // mobileMenu.classList.remove('-is-offscreen');
	          mobileMenuButton.classList.remove('-is-open');
	          document.querySelectorAll('.header_new-mobile-menu-submenu').forEach(function (el) {
	            return el.classList.remove('is-opened');
	          });
	          document.querySelector("html").classList.remove('is-header-open');
	        } else {
	          mobileMenu.classList.add('-is-open');
	          mobileMenuButton.classList.add('-is-open');
	          document.querySelector("html").classList.add('is-header-open');
	        }
	      });
	    }
	
	    var mobileMenuParents = mobileMenu !== null ? mobileMenu.querySelectorAll('li.parent') : [];
	    mobileMenuParents.forEach(function (parent) {
	      parent.addEventListener('click', function (event) {
	        if (event.target === parent) {
	          parent.querySelector('.header_new-mobile-menu-submenu').classList.add('is-opened');
	          // mobileMenu.classList.add('-is-offscreen');
	        }
	      });
	    });
	
	    mobileMenu.querySelectorAll('.header_new-mobile-menu-submenu_back').forEach(function (backButton) {
	      backButton.addEventListener('click', function (event) {
	        event.preventDefault();
	        event.target.closest('.header_new-mobile-menu-submenu').classList.remove('is-opened');
	      });
	    });
	  }
	
	  // ------------------------------------------------------------------
	  // Solutions mobile menu
	  var setupSolutionsMenu = function setupSolutionsMenu() {
	
	    var solutionsMenu = document.querySelector('.solution-detail_menu');
	    var solutionsMenuFooter = document.querySelector('.solution-detail_menu_foot');
	
	    var clickSolutionsMenu = function clickSolutionsMenu(event) {
	      if (solutionsMenu.classList.contains('-is-open')) {
	
	        solutionsMenu.classList.remove('-is-open');
	        (0, _drawing.slideDown)(solutionsMenu.querySelector('ul'), 1000, function () {});
	      } else {
	
	        solutionsMenu.classList.add('-is-open');
	        (0, _drawing.slideUp)(solutionsMenu.querySelector('ul'), 1000, function () {});
	      }
	    };
	
	    var clickSolutionsFooter = function clickSolutionsFooter(event) {
	      if (solutionsMenu.classList.contains('-is-open')) {
	        solutionsMenu.classList.remove('-is-open');
	      } else {
	        solutionsMenu.classList.add('-is-open');
	      }
	    };
	
	    if (solutionsMenu && isMobileView()) {
	      var solutionsMenuHeader = solutionsMenu.querySelector('.solution-detail_menu_head');
	      solutionsMenuHeader.addEventListener('click', clickSolutionsMenu);
	    } else {
	      if (solutionsMenu) {
	        var _solutionsMenuHeader = solutionsMenu.querySelector('.solution-detail_menu_head');
	        _solutionsMenuHeader.removeEventListener('click', clickSolutionsMenu);
	
	        if (solutionsMenuFooter) {
	          solutionsMenuFooter.addEventListener('click', clickSolutionsFooter);
	        }
	      }
	    }
	  };
	  (0, _window.onResize)(function () {
	    return setupSolutionsMenu();
	  });
	  setupSolutionsMenu();
	
	  // ------------------------------------------------------------------
	  // Investor news
	  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    var container, url;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            container = document.querySelector('.hero_investor-news');
	
	            if (container) {
	              _context.next = 3;
	              break;
	            }
	
	            return _context.abrupt('return');
	
	          case 3:
	            url = 'https://investors.tesserent.com/site/feed/1.0/ListPageItems.aspx';
	            _context.next = 6;
	            return __webpack_require__(41).post(url, {
	              categoryid: 199,
	              year: new Date().getFullYear()
	            }).then(function (response) {
	
	              if (!response.data.items) return;
	
	              var index = 0;
	              var items = response.data.items;
	              var feedContainer = container.querySelector('.hero_investor-news_feed');
	              var inTransit = false;
	
	              var firstItem = feedContainer.querySelector('a');
	              var itemTemplate = firstItem.parentNode.innerHTML;
	              var itemAttributes = firstItem.attributes;
	
	              // autoplay
	              var autoplay = void 0;
	              var startAutoPlay = function startAutoPlay() {
	                autoplay = setInterval(function () {
	                  show(index + 1 < items.length - 1 ? index + 1 : 0);
	                }, 8600);
	              };
	
	              // show the news item
	              var show = function show(i) {
	                var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	                if (i === index && first === false) return;
	
	                clearInterval(autoplay);
	
	                // transit begin
	                var beginTransit = function beginTransit(item) {
	
	                  inTransit = true;
	
	                  var ie = feedContainer.querySelector('a');
	                  ie.classList.replace('-transit-in', '-transit-out');
	
	                  setTimeout(function () {
	                    completeTransit(item);
	                  }, 500);
	                };
	
	                // transit complete
	                var completeTransit = function completeTransit(item) {
	
	                  feedContainer.innerHTML = '';
	                  var itemElement = (0, _drawing.newElement)('a', itemAttributes, itemTemplate);
	                  itemElement.href = item.url;
	                  itemElement.querySelector('h4').innerHTML = item.title;
	
	                  var d = new Date(item.effectiveDate);
	                  var df = new Intl.DateTimeFormat('de-DE', {
	                    month: '2-digit',
	                    day: '2-digit',
	                    year: 'numeric'
	                  }).format(d);
	                  itemElement.querySelector('h5.date span').innerHTML = df;
	
	                  itemElement.classList.add('-transit-stop');
	                  feedContainer.appendChild(itemElement);
	
	                  setTimeout(function () {
	                    itemElement.classList.replace('-transit-stop', '-transit-in');
	                    inTransit = false;
	                    startAutoPlay();
	                  }, 5);
	                };
	
	                var item = items[i];
	
	                first ? completeTransit(item) : beginTransit(item);
	
	                index = i;
	              };
	
	              // remove loading class from container
	              container.classList.remove('-loading');
	
	              // hook up arrow buttons
	              var prevButton = container.querySelector('.hero_investor-news_nav button:first-child');
	              var nextButton = container.querySelector('.hero_investor-news_nav button:last-child');
	              prevButton.addEventListener('click', function (event) {
	                if (!inTransit) show(index - 1 > 0 ? index - 1 : 0);
	              });
	              nextButton.addEventListener('click', function (event) {
	                if (!inTransit) show(index + 1 < items.length - 1 ? index + 1 : items.length - 1);
	              });
	
	              // show first
	              show(index, true);
	            }).catch(function (error) {
	              console.log(error);
	            });
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }))();
	
	  // Search toggle (desktop)
	  var searchButton = document.querySelector('.header_menu .header_menu_search_button button');
	  var searchOverlay = document.querySelector('.header_search');
	  if (searchButton && searchOverlay) {
	
	    var searchInput = searchOverlay.querySelector('input');
	    var logoOffset = document.querySelector('.header_logo').offsetWidth + 44;
	    var clickSearchPanel = function clickSearchPanel(event) {
	      event.preventDefault();event.stopPropagation();
	    };
	    var clickOffSearchPanel = function clickOffSearchPanel() {
	      toggleSearchPanel(true);
	    };
	
	    var toggleSearchPanel = function toggleSearchPanel(state) {
	      if (!state) {
	        searchButton.classList.add('-open');
	        searchOverlay.style.left = logoOffset + 'px';
	        searchOverlay.style.opacity = 1;
	        searchOverlay.style.pointerEvents = 'all';
	        searchOverlay.addEventListener('click', clickSearchPanel);
	        document.querySelector('main').addEventListener('click', clickOffSearchPanel);
	        searchInput.focus();
	      } else {
	        searchButton.classList.remove('-open');
	        searchOverlay.style.left = '95%';
	        searchOverlay.style.opacity = 0;
	        searchOverlay.style.pointerEvents = 'none';
	        searchOverlay.removeEventListener('click', clickSearchPanel);
	        document.querySelector('main').removeEventListener('click', clickOffSearchPanel);
	      }
	    };
	    searchButton.addEventListener('click', function (event) {
	      toggleSearchPanel(searchButton.classList.contains('-open'));
	      event.stopImmediatePropagation();
	    });
	  }
	
	  // Search toggle (mobile)
	  var searchButtonMobile = document.querySelector('.header_new-mobile-menu_search_button button');
	  if (searchButtonMobile) {
	    searchButtonMobile.addEventListener('click', function (event) {
	      if (!mobileMenu.classList.contains('-is-open')) {
	        mobileMenu.classList.add('-is-open');
	        mobileMenuButton.classList.add('-is-open');
	        document.querySelector("html").classList.add('is-header-open');
	      }
	
	      mobileMenu.querySelector('.header_new-mobile-menu_search input').focus();
	    });
	  }
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(42);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	var bind = __webpack_require__(44);
	var Axios = __webpack_require__(45);
	var mergeConfig = __webpack_require__(65);
	var defaults = __webpack_require__(50);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  // Factory for creating new instances
	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(63);
	axios.CancelToken = __webpack_require__(68);
	axios.isCancel = __webpack_require__(64);
	axios.VERSION = __webpack_require__(67).version;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(69);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(70);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(44);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return Array.isArray(val);
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return toString.call(val) === '[object FormData]';
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return toString.call(val) === '[object URLSearchParams]';
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	var buildURL = __webpack_require__(46);
	var InterceptorManager = __webpack_require__(47);
	var dispatchRequest = __webpack_require__(48);
	var mergeConfig = __webpack_require__(65);
	var validator = __webpack_require__(66);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(configOrUrl, config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof configOrUrl === 'string') {
	    config = config || {};
	    config.url = configOrUrl;
	  } else {
	    config = configOrUrl || {};
	  }
	
	  if (!config.url) {
	    throw new Error('Provided config url is not valid');
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  if (!config.url) {
	    throw new Error('Provided config url is not valid');
	  }
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	var transformData = __webpack_require__(49);
	var isCancel = __webpack_require__(64);
	var defaults = __webpack_require__(50);
	var Cancel = __webpack_require__(63);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	
	  if (config.signal && config.signal.aborted) {
	    throw new Cancel('canceled');
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	var defaults = __webpack_require__(50);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(43);
	var normalizeHeaderName = __webpack_require__(52);
	var enhanceError = __webpack_require__(53);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(54);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(54);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  };
	  return error;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	var settle = __webpack_require__(55);
	var cookies = __webpack_require__(57);
	var buildURL = __webpack_require__(46);
	var buildFullPath = __webpack_require__(58);
	var parseHeaders = __webpack_require__(61);
	var isURLSameOrigin = __webpack_require__(62);
	var createError = __webpack_require__(56);
	var defaults = __webpack_require__(50);
	var Cancel = __webpack_require__(63);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }
	
	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || defaults.transitional;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
	        request.abort();
	        request = null;
	      };
	
	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(56);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(53);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(59);
	var combineURLs = __webpack_require__(60);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	
	  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
	  });
	
	  return config;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VERSION = __webpack_require__(67).version;
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	    }
	
	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}
	
	module.exports = {
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = {
	  "version": "0.25.0"
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(63);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	
	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;
	
	    var i;
	    var l = token._listeners.length;
	
	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });
	
	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);
	
	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };
	
	    return promise;
	  };
	
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Subscribe to the cancel signal
	 */
	
	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }
	
	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	
	/**
	 * Unsubscribe from the cancel signal
	 */
	
	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(43);
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pageBannerSection;
	
	var _swiper = __webpack_require__(72);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Hero controls.
	 */
	function pageBannerSection() {
	
	  // Is there a hero swiper?
	  var element = document.querySelector('.page-banner_swiper');
	  if (!element) return;
	
	  // Load 'er up
	  (0, _swiper2.default)(element, function (swiper) {
	
	    // Settings
	    var settings = JSON.parse(element.dataset.pageBannerSwiper);
	    if (!settings) return;
	
	    // Events
	    settings.on = {
	
	      afterInit: function afterInit() {
	        element.classList.add('-started');
	      },
	
	      slideChangeTransitionStart: function slideChangeTransitionStart() {
	
	        var currentSlideBG = document.querySelector('.swiper-slide-visible .page-banner_swiper_slide_bg');
	        currentSlideBG.classList.remove('-scaling');
	      },
	
	      slideChangeTransitionEnd: function slideChangeTransitionEnd() {
	
	        var currentSlideBG = document.querySelector('.swiper-slide-visible .page-banner_swiper_slide_bg');
	        currentSlideBG.classList.add('-scaling');
	      }
	
	      // Init
	    };var slides = element.querySelectorAll('.swiper-slide');
	    if (slides.length >= 1) {
	      var swiperInstance = new swiper(element, settings);
	    }
	  });
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = swiperDirective;
	
	var _request = __webpack_require__(27);
	
	var _drawing = __webpack_require__(10);
	
	/**
	 * @module directives/media/swiper
	 */
	
	var cssAdded = false;
	var swiperDirectory = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/7.4.1/';
	function swiperDirective() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	
	  // Add style elements to head
	  if (!cssAdded) {
	    cssAdded = true;
	    document.head.appendChild((0, _drawing.newElement)('link', {
	      type: 'text/css',
	      rel: 'stylesheet',
	      href: swiperDirectory + 'swiper-bundle.min.css'
	    }));
	  }
	
	  // Load in swiper lib
	
	  var test = function test() {
	    return window.Swiper !== null && window.Swiper !== undefined;
	  };
	  (0, _request.dependency)(swiperDirectory + 'swiper-bundle.min.js', test).then(function () {
	
	    // Declare ready and callback
	    if (element) (0, _drawing.frame)(function () {
	      return element.classList.add('swiper-ready');
	    });
	    if (callback) callback(window.Swiper);
	  });
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = heroSection;
	
	var _swiper = __webpack_require__(72);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Hero controls.
	 */
	function heroSection() {
	
	  // Is there a hero swiper?
	  var element = document.querySelector('.hero_swiper');
	  if (!element) return;
	
	  // Load 'er up
	  (0, _swiper2.default)(element, function (swiper) {
	
	    // Settings
	    var settings = JSON.parse(element.dataset.heroSwiper);
	    if (!settings) return;
	
	    // Events
	    settings.on = {
	
	      afterInit: function afterInit() {
	        element.classList.add('-started');
	      },
	
	      slideChangeTransitionStart: function slideChangeTransitionStart() {
	
	        var currentSlideContainer = document.querySelector('.swiper-slide-visible .hero_swiper_slide_content_container');
	        if (currentSlideContainer) currentSlideContainer.classList.remove('-is-ready');
	
	        var currentSlideBG = document.querySelector('.swiper-slide-visible .hero_swiper_slide_bg');
	        if (currentSlideBG) currentSlideBG.classList.remove('-scaling');
	      },
	
	      slideChangeTransitionEnd: function slideChangeTransitionEnd() {
	
	        var currentSlideContainer = document.querySelector('.swiper-slide-visible .hero_swiper_slide_content_container');
	        if (currentSlideContainer) currentSlideContainer.classList.add('-is-ready');
	
	        var currentSlideBG = document.querySelector('.swiper-slide-visible .hero_swiper_slide_bg');
	        if (currentSlideBG) currentSlideBG.classList.add('-scaling');
	      }
	
	      // Init
	    };var slides = element.querySelectorAll('.swiper-slide');
	    if (slides.length > 1) {
	      var swiperInstance = new swiper(element, settings);
	
	      // Bullets  
	      var bullets = element.querySelectorAll('.hero_swiper_bullets .bullet');
	      var slideEnter = function slideEnter(index) {
	        bullets.forEach(function (bullet) {
	          if (index == bullet.dataset.slide) {
	            bullet.classList.remove('-exiting');
	            bullet.classList.add('-active');
	          }
	        });
	      };
	
	      // Bullet animations
	      slideEnter(0);
	      swiperInstance.on('slideChangeTransitionEnd', function () {
	        return slideEnter(swiperInstance.realIndex);
	      });
	      swiperInstance.on('slideChangeTransitionStart', function () {
	        bullets.forEach(function (bullet) {
	          bullet.classList.replace('-active', '-exiting');
	        });
	      });
	
	      // Bullet clicks
	      bullets.forEach(function (bullet) {
	        bullet.addEventListener('click', function (event) {
	          swiperInstance.slideToLoop(parseInt(bullet.dataset.slide));
	        });
	      });
	    }
	  });
	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = articlesSection;
	
	var _drawing = __webpack_require__(10);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Insights and resources articles controls.
	 */
	function articlesSection() {
	
	  // Fetch insights articles
	  var updateInsights = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(filter) {
	      var showLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              // Clear any empty arrays from filter value
	              filter.value = filter.value.filter(function (value) {
	                return value.length > 0;
	              });
	
	              // Check header items (show/hide clear button)
	              clearFiltersButton.classList[filter.value.length > 0 ? 'remove' : 'add']('+hidden');
	
	              // Loading indicator/s
	              if (showLoading) {
	                loadMoreButton.parentNode.classList.add('+hidden');
	                resultsContainer.classList.replace('-loaded', '-loading');
	              }
	
	              // Fetch insights articles
	              _context.next = 5;
	              return axios.post('?p=actions/tesserent/articles/fetch', {
	                CSRF_TOKEN: window.csrfToken,
	                section: articleSection,
	                filters: Object.assign(filter, {
	                  limit: resultsLimit, page: page
	                })
	              }).then(function (response) {
	                reRender(response);
	              }).catch(function (error) {
	                console.log(error);
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function updateInsights(_x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  // Filter group buttons
	
	
	  var axios = __webpack_require__(41).create({
	    headers: {
	      'X-CSRF-Token': window.csrfToken
	    }
	  });
	
	  var articleSection = document.querySelector('div[data-section-handle]') ? document.querySelector('div[data-section-handle]').getAttribute('data-section-handle') : false;
	  if (!articleSection) return;
	
	  var filterButtonsContainer = document.querySelector('.insights_filters_buttons');
	  if (!filterButtonsContainer) return;
	
	  var resultsContainer = document.querySelector('.insights_results');
	  var cardContainer = resultsContainer.querySelector('.body_cards > .container > .grid');
	
	  var filterButtons = filterButtonsContainer.querySelectorAll('button.button');
	  var optionsButtons = document.querySelectorAll('.insights_filters_drop-down button');
	
	  var clearFiltersButton = filterButtonsContainer.querySelector('button.insights_filters_buttons-remove');
	  var loadMoreButton = document.getElementById('insights-load-more-button');
	  var loadMoreButtonMessage = loadMoreButton.innerHTML;
	
	  var page = 1,
	      limit = 12;
	  var cardTemplate = null,
	      cardAttributes = null,
	      selectedGroup = null;
	  var selectedOptions = [];
	
	  // Setup sub arrays for filters
	  filterButtons.forEach(function (button) {
	    selectedOptions.push([]);
	  });
	
	  var defaultResultsLimit = parseInt(loadMoreButton.dataset.defaultLimit) || 8;
	  var resultsLimit = defaultResultsLimit;
	
	  // Expand options drop downs
	  var toggleOptions = function toggleOptions(group) {
	
	    selectedGroup = selectedGroup !== group ? group : null;
	
	    document.querySelectorAll('.insights_filters_drop-down').forEach(function (dropdown) {
	      if (dropdown.dataset.filterName !== group) (0, _drawing.slideDown)(dropdown, 80, function () {
	        dropdown.classList.replace('-is-open', '-is-closed');
	      });
	    });
	
	    var target = document.querySelector('.insights_filters_drop-down[data-filter-name="' + group + '"]');
	    if (target) {
	
	      if (target.classList.contains('-is-open')) {
	
	        (0, _drawing.slideDown)(target, 160, function () {
	          target.classList.replace('-is-open', '-is-closed');
	        });
	      } else {
	
	        (0, _drawing.slideUp)(target, 160, function () {
	          target.classList.replace('-is-closed', '-is-open');
	        });
	      }
	    }
	  };
	
	  // Redraw insights articles
	  var reRender = function reRender(insights) {
	
	    // Get the card template
	    if (!cardTemplate) {
	      var firstCard = cardContainer.querySelector('.card');
	
	      if (firstCard) {
	        cardTemplate = firstCard.parentNode.innerHTML;
	        cardAttributes = firstCard.attributes;
	      }
	    }
	
	    // Render result
	    cardContainer.innerHTML = '';
	    if (insights.data.length < 1) {
	
	      // No results
	      var result = (0, _drawing.newElement)('div', {}, '<div class="card no-resilts"><h2>No articles found.</h2></div>');
	      cardContainer.appendChild(result);
	
	      // Hide load more button
	      loadMoreButton.parentNode.classList.add('+hidden');
	    } else {
	
	      // Show results (to limit)
	      insights.data.slice(0, resultsLimit).forEach(function (insight) {
	        var card = (0, _drawing.newElement)('div', cardAttributes, cardTemplate);
	
	        card.querySelector('.card_content_meta').innerHTML = insight.type;
	
	        // need to strip any source information
	        var imageBlock = card.querySelector('.card_content_thumbnail picture');
	        if (imageBlock) {
	          var imageBlockImg = imageBlock.querySelector('img');
	          var imageBlockSource = imageBlock.querySelector('source');
	          if (imageBlockSource) imageBlockSource.remove();
	          if (imageBlockImg) imageBlockImg.removeAttribute('srcset');
	          if (insight.image) {
	            imageBlockImg.src = insight.image;
	          } else {
	            imageBlockImg.remove();
	          }
	        }
	        card.querySelector('.card_content_title a.h4').href = insight.url;
	        card.querySelector('.card_content_title a.h4').innerHTML = insight.title;
	        cardContainer.appendChild(card);
	        card.addEventListener('click', function (event) {
	          document.location.href = insight.url;
	        });
	      });
	
	      // Reset and show/hide load mode button
	      loadMoreButton.innerHTML = loadMoreButtonMessage;
	      if (insights.data.length > resultsLimit) {
	        loadMoreButton.parentNode.classList.remove('+hidden');
	      } else {
	        loadMoreButton.parentNode.classList.add('+hidden');
	      }
	    }
	
	    // Loaded
	    resultsContainer.classList.replace('-loading', '-loaded');
	  };var clickFilterButton = function clickFilterButton(event) {
	
	    var group = event.target.dataset.filterName;
	    filterButtons.forEach(function (b) {
	      return b.classList.remove('-selected');
	    });
	
	    if (group !== selectedGroup) event.target.classList.add('-selected');
	    toggleOptions(group);
	  };
	  filterButtons.forEach(function (button) {
	    return button.addEventListener('click', clickFilterButton);
	  });
	
	  // Option buttons
	  optionsButtons.forEach(function (button) {
	    button.addEventListener('click', function (event) {
	
	      var group = button.parentNode.dataset.filterName;
	      var index = parseInt(button.parentNode.dataset.filterIndex);
	      var value = button.dataset.filterValue;
	      var filterButton = document.querySelector('button[data-filter-name="' + group + '"]');
	
	      if (selectedOptions[index].includes(value)) {
	
	        // Remove from selectedOptions
	        var vi = selectedOptions[index].indexOf(value);
	        if (vi > -1) selectedOptions[index].splice(vi, 1);
	        button.classList.remove('-selected');
	
	        // If there are no selected options in this group then unset hilite on group button
	        var hasSelections = false;
	        var options = button.parentNode.querySelectorAll('button');
	        options.forEach(function (b) {
	          if (b.classList.contains('-selected')) hasSelections = true;
	        });
	        if (hasSelections) {
	          if (filterButton) filterButton.classList.add('-has-selections');
	        } else {
	          if (filterButton) filterButton.classList.remove('-has-selections');
	        }
	      } else {
	
	        // Add to selectedOptions
	        selectedOptions[index].push(value);
	        button.classList.add('-selected');
	
	        // Add hilite to selected group button
	        if (filterButton) filterButton.classList.add('-has-selections');
	      }
	
	      // Always reset results limit
	      resultsLimit = defaultResultsLimit;
	
	      // Update results
	      updateInsights({
	        label: group,
	        value: selectedOptions
	      });
	    });
	  });
	
	  // Load more button
	  loadMoreButton.addEventListener('click', function (event) {
	
	    // Increase limit and update
	    loadMoreButton.innerHTML = 'Loading...';
	    resultsLimit = resultsLimit + defaultResultsLimit;
	
	    updateInsights({
	      label: null,
	      value: selectedOptions
	    }, false);
	  });
	
	  // Clear all button
	  clearFiltersButton.addEventListener('click', function (event) {
	
	    // Clear filter selection classes
	    filterButtons.forEach(function (button) {
	      button.classList.remove('-selected');
	      button.classList.remove('-has-selections');
	    });
	
	    // Close all option dropdowns
	    toggleOptions(null);
	
	    // Clear option selection classes
	    optionsButtons.forEach(function (button) {
	      button.classList.remove('-selected');
	    });
	
	    // Always reset results limit
	    resultsLimit = defaultResultsLimit;
	
	    // Clear filter values and update
	    selectedOptions = selectedOptions.map(function (value) {
	      return [];
	    });
	    updateInsights({
	      label: null,
	      value: selectedOptions
	    });
	  });
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = logosSection;
	
	var _swiper = __webpack_require__(72);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Logo swiper controls.
	 */
	function logosSection() {
	
	  // Is there a logo swiper?
	  var element = document.querySelector('.logos_swiper');
	  if (!element) return;
	
	  (0, _swiper2.default)(element, function (swiper) {
	
	    // Settings
	    var settings = JSON.parse(element.dataset.logosSwiper);
	    if (!settings) return;
	
	    // Init
	    var slides = element.querySelectorAll('.swiper-slide');
	    if (slides.length > 1) {
	
	      var swiperInstance = new swiper(element, settings);
	    }
	  });
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cardsSection;
	
	var _swiper = __webpack_require__(72);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Logo swiper controls.
	 */
	function cardsSection() {
	
	  // Expander cards
	  var expandMoreButtons = document.querySelectorAll('.button.-expand-more');
	  if (expandMoreButtons) {
	    expandMoreButtons.forEach(function (slmb) {
	      slmb.addEventListener('click', function (event) {
	
	        var section = slmb.closest(".body_section").querySelector(".body_cards.-expanding");
	        if (section) {
	          var cards = section.querySelectorAll('.card');
	          cards.forEach(function (card) {
	            card.classList.remove('-expand-hide');
	          });
	        }
	        slmb.remove();
	      });
	    });
	  }
	
	  // general clicks
	  document.querySelectorAll('div.card_content:not(.-no-link)').forEach(function (card) {
	    var anchor = card.querySelector('a');
	    if (anchor) card.addEventListener('click', function (event) {
	      document.location.href = anchor.href;
	    });
	  });
	
	  // Is there a logo swiper?
	  var elements = document.querySelectorAll('.cards_swiper');
	  if (elements.length < 1) return;
	
	  elements.forEach(function (element) {
	    (0, _swiper2.default)(element, function (swiper) {
	
	      // Settings
	      var settings = JSON.parse(element.dataset.cardsSwiper);
	      if (!settings) return;
	
	      // Init
	      var slides = element.querySelectorAll('.swiper-slide');
	      if (slides.length > 1) {
	
	        var swiperInstance = new swiper(element, settings);
	
	        // Bullets  
	        var bullets = element.querySelectorAll('.hero_swiper_bullets.-in-page .bullet');
	        var slideEnter = function slideEnter(index) {
	          bullets.forEach(function (bullet) {
	            if (index == bullet.dataset.slide) {
	              bullet.classList.remove('-exiting');
	              bullet.classList.add('-active');
	            }
	          });
	        };
	
	        // Bullet animations
	        slideEnter(0);
	        swiperInstance.on('slideChangeTransitionEnd', function () {
	          return slideEnter(swiperInstance.realIndex);
	        });
	        swiperInstance.on('slideChangeTransitionStart', function () {
	          bullets.forEach(function (bullet) {
	            bullet.classList.replace('-active', '-exiting');
	          });
	        });
	
	        // Bullet clicks
	        bullets.forEach(function (bullet) {
	          bullet.addEventListener('click', function (event) {
	            swiperInstance.slideToLoop(parseInt(bullet.dataset.slide));
	          });
	        });
	      }
	    });
	  });
	}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = countdownSection;
	/**
	 * Countdown block functionality.
	 */
	function countdownSection() {
	  var countdownEles = document.querySelectorAll("[data-countdown]");
	
	  countdownEles.forEach(function (countdownEle) {
	    var endDateTimestamp = parseInt(countdownEle.dataset.countdown);
	
	    var endDate = new Date(endDateTimestamp);
	
	    var timezone = endDate.getTimezoneOffset() / 60 * -1 == 10 ? 'AEST' : 'AEDT';
	
	    countdownEle.querySelector('.end-date').innerText += ' ' + timezone;
	
	    var countdown = setInterval(function () {
	      var timeUntil = (endDate - Date.now()) / 1000;
	
	      var newCount = {
	        days: timeUntil / 86400,
	        hours: timeUntil % 86400 / 3600,
	        minutes: timeUntil % 3600 / 60,
	        seconds: timeUntil % 60
	      };
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(newCount)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _ref = _step.value;
	
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var key = _ref2[0];
	          var value = _ref2[1];
	
	          countdownEle.querySelector('.timer .' + key + ' .value').innerText = value <= 0 ? '0' : Math.floor(value);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      ;
	
	      if (timeUntil <= 0) {
	        return clearInterval(countdown);
	      }
	    }, 1000);
	  });
	}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = videoSection;
	function videoSection() {
	
	  var videoPopup = document.getElementById('videoWindow');
	  if (!videoPopup) return;
	
	  var videoFrame = videoPopup.querySelector('iframe');
	
	  var openVideo = function openVideo(url) {
	
	    // console.log('url', url);
	
	    if (!url) return;
	
	    videoPopup.classList.add('open');
	    videoPopup.classList.remove('closed');
	
	    videoFrame.setAttribute('src', url.split('?')[0] + '?autoplay=1'); // strip any query parameters (rough)
	
	    document.body.classList.toggle('locked');
	  };
	
	  var closeVideo = function closeVideo() {
	
	    videoPopup.classList.remove('open');
	    videoPopup.classList.add('closed');
	
	    setTimeout(function () {
	      // reset src after fadeout
	      videoFrame.setAttribute('src', '');
	    }, 700);
	
	    document.body.classList.toggle('locked');
	  };
	
	  /** close the video on general click */
	  videoPopup.addEventListener('click', function (event) {
	    closeVideo();
	  });
	
	  /** click the play button */
	  var videoLinks = document.querySelectorAll('[data-video-url]');
	  videoLinks.forEach(function (videoLink) {
	    videoLink.addEventListener('click', function (event) {
	      openVideo(videoLink.dataset.videoUrl);
	    });
	  });
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = hsFormSection;
	
	var _jsCookie = __webpack_require__(80);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _validator = __webpack_require__(24);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _recaptcha = __webpack_require__(26);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _floatLabel = __webpack_require__(23);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var tempId = 0;
	
	function hsFormSection() {
	  var _this = this;
	
	  var forms = [].concat(_toConsumableArray(document.querySelectorAll('form.hs-form')));
	
	  forms.forEach(function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee($form) {
	      var hapiKey, portalId, formGuid, recaptchaCallback, recaptchaSiteKey, $cols, form, hubspotFormEndpoint, formData, response, $lastCol, richTextFlag, legal, checkboxes, consentText, privacyText;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              hapiKey = $form.getAttribute('data-hs-api-key');
	              portalId = $form.getAttribute('data-hs-portal-id');
	              formGuid = $form.getAttribute('data-hs-form-guid');
	              recaptchaCallback = $form.getAttribute('data-sw-temp-recaptcha');
	              recaptchaSiteKey = $form.getAttribute('data-sw-recaptcha-sitekey');
	              $cols = document.createElement('div');
	
	              $cols.classList.add('columns', '-h-gap-smx', '-v-gap-smx');
	              form = void 0;
	              hubspotFormEndpoint = '/hubspot-form';
	              formData = new FormData();
	
	
	              formData.append(csrfTokenName, csrfTokenValue);
	              formData.append('formGuid', formGuid);
	
	              $form.append($cols);
	
	              // $form.addEventListener('submit', handleFormSubmit);
	
	              _context.next = 15;
	              return fetch(hubspotFormEndpoint, {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json'
	                },
	                body: formData
	              });
	
	            case 15:
	              response = _context.sent;
	              _context.prev = 16;
	              _context.next = 19;
	              return response.json();
	
	            case 19:
	              form = _context.sent;
	              $lastCol = void 0;
	              richTextFlag = void 0;
	              legal = form.legalConsentOptions;
	
	              // form.metaData.forEach(e => {
	              //   if (e.name === 'legalConsentOptions') {
	              //     legal = {
	              //       name: e.name,
	              //       value: JSON.parse(e.value)
	              //     }
	              //   }
	              // });
	
	              // form.fieldGroups.forEach(g => {
	
	              //   console.log(g);
	
	
	              //   if (fields && fields.length) {
	
	              //     console.log(fields);
	
	              //   }
	
	              // });
	
	              form.fieldGroups.forEach(function (group) {
	
	                var $col = void 0;
	
	                var groupFields = group.fields;
	                var groupFieldsLength = groupFields && groupFields.length ? groupFields.length : 0;
	                var groupRichText = group.richText;
	
	                var widthClass = '@desk-' + (groupFieldsLength === 2 ? '6' : '12');
	
	                if (groupFieldsLength > 0) {
	
	                  groupFields.forEach(function (field) {
	
	                    // console.log(field);
	
	                    $col = document.createElement('div');
	                    $col.classList.add('column', widthClass);
	                    $cols.append($col);
	                    richTextFlag = false;
	
	                    if (field.fieldType === 'single_line_text' || field.fieldType === 'email' || field.fieldType === 'phone') {
	                      $col.append(getInputField(field));
	                    } else if (field.fieldType === 'multi_line_text') {
	                      $col.append(getTextareaField(field));
	                    } else if (field.fieldType === 'single_checkbox') {
	                      $col.append(getRadioSelectField(field));
	                    } else if (field.fieldType === 'multiple_checkboxes') {
	
	                      widthClass = '6';
	
	                      $col.append(getCheckboxField(field));
	                    } else if (field.fieldType === 'dropdown') {
	                      $col.append(getRadioSelectField(field));
	                    }
	                  });
	                }
	
	                if (groupRichText) {
	
	                  if (richTextFlag) {
	                    $col = $lastCol;
	                  } else {
	                    $col = document.createElement('div');
	                    $col.classList.add('column', widthClass, 'text');
	                    $cols.append($col);
	                  }
	
	                  $col.append(createElementFromHTML('\n\t\t\t\t\t\t<div class="container -width-9 -align-left">\n\t\t\t\t\t\t\t<div class="text +text-left">\n\t\t\t\t\t\t\t\t' + groupRichText + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t'));
	
	                  richTextFlag = true;
	                  $lastCol = $col;
	                }
	
	                $lastCol = $col;
	              });
	
	              if (legal) {
	
	                // console.log(legal);
	
	                checkboxes = legal.communicationsCheckboxes;
	                consentText = reformatText(legal.communicationConsentText, 'h4');
	                privacyText = reformatText(legal.privacyText, 'h4') + reformatText(legal.consentToProcessText, 'h4');
	
	
	                $cols.append(getConsentField(checkboxes, consentText, privacyText));
	
	                $cols.append(createElementFromHTML('<input type="hidden" name="legalConsentOptions[communicationConsentText]" value="' + legal.communicationConsentText + '">'));
	                $cols.append(createElementFromHTML('<input type="hidden" name="legalConsentOptions[consentToProcessText]" value="' + legal.consentToProcessText + '">'));
	              }
	
	              // Add submit button with recaptcha if defined
	              $cols.append(createElementFromHTML('\n        <div class="column @desk-12">\n          <button\n            type="submit" \n            class="button -submit ' + (recaptchaCallback.length && recaptchaSiteKey.length ? ' g-recaptcha' : '') + '"\n            data-sitekey="' + recaptchaSiteKey + '"\n            data-callback="' + recaptchaCallback + '"\n          >\n            Submit Enquiry\n          </button>\n        </div>\n      '));
	
	              // Initialize the new sw-float-labels
	              (0, _floatLabel2.default)(document.body);
	
	              // if (Cookies.get('hubspotutk')) {
	              //   $form.append(createElementFromHTML(`<input type="hidden" name="cookieValue" value="${Cookies.get('hubspotutk')}" />`));
	              // }
	
	              checkCookie($form);
	
	              $form.setAttribute('data-sw-validator', 'true');
	              $form.setAttribute('data-sw-recaptcha', recaptchaCallback);
	
	              // Validation/recap
	              (0, _validator2.default)();
	              (0, _recaptcha2.default)();
	
	              // Hook up recaptcha
	              if (recaptchaCallback.length && window.loadRecaptcha) window.loadRecaptcha();
	
	              // Drift - parse out the form data and stage it for drift (this is awful)
	              if (window.drift) {
	                window.hsFormWillSubmit = function (event) {
	                  var f = new FormData($form);
	                  var _data = {};
	                  var _iteratorNormalCompletion = true;
	                  var _didIteratorError = false;
	                  var _iteratorError = undefined;
	
	                  try {
	                    for (var _iterator = f.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                      var _ref2 = _step.value;
	
	                      var _ref3 = _slicedToArray(_ref2, 2);
	
	                      var key = _ref3[0];
	                      var value = _ref3[1];
	
	                      if (key.includes('formData[')) {
	                        var fn = key.split('formData[')[1].split(']')[0];
	                        if (key.includes('[]')) {
	                          (function () {
	                            var cv = [],
	                                ch = document.getElementsByName('formData[' + fn + '][]');
	                            if (ch) {
	                              ch.forEach(function (c) {
	                                if (c.checked) {
	                                  cv.push(c.value);
	                                }
	                              });
	                              _data[fn] = cv.join(',');
	                            }
	                          })();
	                        } else {
	                          _data[fn] = value;
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                      }
	                    } finally {
	                      if (_didIteratorError) {
	                        throw _iteratorError;
	                      }
	                    }
	                  }
	
	                  window.drift.api.stageFormData(_data);
	                  return true; // have to
	                };
	              }
	              _context.next = 38;
	              break;
	
	            case 36:
	              _context.prev = 36;
	              _context.t0 = _context['catch'](16);
	
	            case 38:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[16, 36]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }()
	  // Could not resolve JSON for this form
	  );
	}
	
	function checkCookie($form) {
	  if (_jsCookie2.default.get('hubspotutk')) {
	    $form.append(createElementFromHTML('<input type="hidden" name="cookieValue" value="' + _jsCookie2.default.get('hubspotutk') + '" />'));
	  } else {
	    setTimeout(function () {
	      return checkCookie($form);
	    }, 1000);
	  }
	}
	
	function getInMessage(message) {
	  var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return '\n    ' + (divider ? '<hr class="h-divider +t-margin-none">' : '') + '\n    <div class="container -width-12 -align-left">\n      <div class="text +text-left +v-trim">\n        ' + message + '\n      </div>\n    </div>\n\t';
	}
	
	function reformatText(str) {
	  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'p';
	
	  var newStr = str.replace('<p>', '').replace('</p>', '');
	
	  return '<' + tag + '><mark>' + newStr + '</mark></' + tag + '>';
	}
	
	function getTextareaField(field) {
	  tempId++;
	
	  return createElementFromHTML('\n\t\t<div data-sw-float-label class="float-label -type-textarea is-invalid">\n\t\t\t<label class="float-label_label" for="' + tempId + '">' + field.label + (field.required ? '*' : '') + '</label>\n\t\t\t<textarea\n\t\t\t\tclass="float-label_field"\n\t\t\t\tid="' + tempId + '"\n\t\t\t\tname="formData[' + field.name + ']"\n\t\t\t\t' + (field.required ? 'required' : '') + '\n\t\t\t\trows="4"\n\t\t\t\tspellcheck="false"\n\t\t\t\tdata-sw-autosize\n\t\t\t></textarea>\n\t\t</div>\n\t');
	}
	
	function getInputField(field) {
	  tempId++;
	  var type = field.type;
	  var pattern = void 0;
	
	  if (field.name === 'email') {
	    type = 'email';
	  } else if (field.name === 'phone') {
	    type = 'tel';
	  }
	
	  return createElementFromHTML('\n\t\t<div data-sw-float-label class="float-label -type-text -type-input is-invalid">\n\t\t\t<label class="float-label_label" for="' + tempId + '">\n\t\t\t\t' + field.label + (field.required ? '*' : '') + '\n\t\t\t</label>\n\t\t\t<input\n\t\t\t\tclass="float-label_field"\n\t\t\t\tid="' + tempId + '"\n\t\t\t\tname="formData[' + field.name + ']"\n\t\t\t\ttype="' + type + '"\n\t\t\t\t' + (field.required ? 'required' : '') + '\n\t\t\t\t' + (pattern ? 'pattern="' + pattern + '"' : '') + '\n\t\t\t/>\n\t\t</div>\n\t');
	}
	
	function getRadioSelectField(field) {
	  tempId++;
	
	  return createElementFromHTML('\n\t\t<div data-sw-float-label class="float-label -type-select is-filled">\n\t\t\t<label class="float-label_label" for="' + tempId + '">\n\t\t\t\t' + field.label + (field.required ? '*' : '') + '\n\t\t\t</label>\n\n\t\t\t<select\n\t\t\t\tclass="float-label_field"\n\t\t\t\tid="' + tempId + '"\n\t\t\t\tname="formData[' + field.name + ']"\n\t\t\t\trequired\n\t\t\t>\n\t\t\t\t<option selected></option>\n\n\t\t\t\t' + field.options.map(function (option) {
	    return '\n\t\t\t\t\t<option value="' + option.value + '">' + option.label + '</option>\n\t\t\t\t';
	  }).join('') + '\n\t\t\t</select>\n\n\t\t\t<span class="float-label_arrow">\n\t\t\t\t<i aria-hidden="true" class="icon"><svg version="1.1" id="Plus" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve"><path d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601 C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399 C15.952,9,16,9.447,16,10z"/></svg></i>\n\t\t\t</span>\n\t\t</div>\n\t');
	}
	
	function getCheckboxField(field) {
	  tempId++;
	
	  var str = '';
	
	  field.options.forEach(function (option) {
	    tempId++;
	    str += '\n\t\t\t\t<div class="cell">\n\t\t\t\t\t\t<div class="checkbox">\n\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\tid="' + tempId + '"\n\t\t\t\t\t\t\t\ttype="checkbox"\n\t\t\t\t\t\t\t\tname="formData[' + field.name + '][]"\n\t\t\t\t\t\t\t\tvalue="' + option.value + '"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<label for="' + tempId + '">\n\t\t\t\t\t\t\t\t<span class="checkbox_marker">\n\t\t\t\t\t\t\t\t\t<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polygon fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" points="20,2.25 7.5,14.75 4,11.25      0.5,14.75 7.5,21.75 23.5,5.75    "></polygon></g></g><g id="New_icons_1_"></g></g><g id="Invisible_Shape"><rect fill="none" width="24" height="24"></rect></g></svg></i>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class="checkbox_label">' + option.label + '</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t';
	  });
	
	  return createElementFromHTML('\n\t\t<div class="form-checkboxes">\n      <div class="bar -h-gap-sm -h-align-left">\n        <label class="float-label_label +t-margin-xs +b-margin-xs">\n          ' + field.label + '\n        </label>\n      </div>\n      <div class="grid -has-2 -h-gap-sm -h-align-left">\n        ' + str + '\n      </div>\n\t\t</div>\n\t');
	}
	
	function getConsentField(options, before, after) {
	  tempId++;
	
	  var str = '';
	
	  options.forEach(function (option) {
	    tempId++;
	    str += '\n\t\t\t\t<div class="cell">\n\t\t\t\t\t\t<div class="checkbox">\n\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\tid="' + tempId + '"\n\t\t\t\t\t\t\t\ttype="checkbox"\n\t\t\t\t\t\t\t\tname="legalConsentOptions[receive]"\n\t\t\t\t\t\t\t\tvalue="' + option.subscriptionTypeId + '"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<label for="' + tempId + '">\n\t\t\t\t\t\t\t\t<span class="checkbox_marker">\n\t\t\t\t\t\t\t\t\t<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polygon fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" points="20,2.25 7.5,14.75 4,11.25      0.5,14.75 7.5,21.75 23.5,5.75    "></polygon></g></g><g id="New_icons_1_"></g></g><g id="Invisible_Shape"><rect fill="none" width="24" height="24"></rect></g></svg></i>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span class="checkbox_label">' + option.label + '</span>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t';
	  });
	
	  // console.log(options);
	  // console.log(before);
	  // console.log(after);
	  return createElementFromHTML('\n    <div class="column @desk-12">\n      <div class="+b-margin-xs">' + getInMessage(before, true) + '</div>\n      <div class="form-checkboxes">\n        <div class="grid -has-1 -h-gap-sm -h-align-left">\n          ' + str + '\n        </div>\n      </div>\n      <div class="+t-margin-xs">' + getInMessage(after) + '</div>\n    </div>\n\t');
	}
	
	function createElementFromHTML(htmlString) {
	  var div = document.createElement('div');
	  div.innerHTML = htmlString.trim();
	
	  return div.firstChild;
	}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = footerSection;
	
	var _jsCookie = __webpack_require__(80);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Footer controls.
	 */
	function footerSection() {
	
	  // Send form function
	  var sendForm = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var settings, context, body, url;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	
	              // Get form settings
	              settings = JSON.parse(hubspotNewsletterForm.dataset.hubspotData);
	
	              if (settings) {
	                _context.next = 3;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 3:
	
	              // HS specific form body (from https://legacydocs.hubspot.com/docs/methods/forms/submit_form)
	              context = {
	                "pageUri": settings.pageUri,
	                "pageName": settings.pageName
	              };
	
	              if (_jsCookie2.default.get('hubspotutk')) context["hutk"] = _jsCookie2.default.get('hubspotutk'); // If tracking exists add it
	              body = {
	                "submittedAt": Date.now(),
	                "fields": [{
	                  "objectTypeId": "0-1",
	                  "name": "email",
	                  "value": hubspotNewsletterForm.querySelector('input[type="email"]').value
	                }],
	                "context": context,
	                "legalConsentOptions": {
	                  "consent": { // Include this object when GDPR options are enabled
	                    "consentToProcess": true,
	                    "text": "I agree to receive other communications from Tesserent."
	                  }
	                }
	              };
	
	              // Post form
	
	              url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + settings.portalId + '/' + settings.formGuid;
	              _context.next = 9;
	              return __webpack_require__(41).post(url, body, {
	                'Content-Type': 'application/json'
	              }).then(function (response) {
	                if (response.status === 200) {
	                  hubspotNewsletterForm.innerHTML = '<div class="text">\n          <p class="+v-margin-none">\n            ' + (response.data.inlineMessage ? response.data.inlineMessage : 'Thanks!') + '\n          </p>\n        </div>';
	                } else {
	                  console.error(error);
	                }
	              }).catch(function (error) {
	                console.error(error);
	              }).then(function () {
	                hubspotNewsletterForm.classList.remove('-posting');
	              });
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function sendForm() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  // Submit event
	
	
	  var hubspotNewsletterForm = document.getElementById('hubspotNewsletterForm');
	  if (!hubspotNewsletterForm) return;hubspotNewsletterForm.addEventListener('submit', function (event) {
	
	    event.preventDefault();
	
	    // Post it...
	    hubspotNewsletterForm.classList.add('-posting');
	    sendForm();
	  });
	}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = notificationSection;
	function notificationSection() {
	  document.querySelectorAll('[sw-notification]').forEach(function (notification) {
	    var dateUpdated = notification.getAttribute('sw-notification');
	    var notified = window.localStorage.getItem('notified-' + notification.id) === dateUpdated;
	
	    if (!notified) {
	      document.body.classList.add('is-showing-' + notification.id);
	      var closeButton = notification.querySelector('.notification_close');
	
	      if (closeButton !== null) {
	        closeButton.addEventListener('click', function () {
	          document.body.classList.remove('is-showing-' + notification.id);
	          window.localStorage.setItem('notified-' + notification.id, dateUpdated);
	        });
	      }
	    }
	  });
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js